export type Link = {
    name: string;
    route: string;

    children?: Link[];
    hash?: string;
}

export type BaseAboutUsData = {
    anchor: string;
    title: string;
    subtitle: string;
    img: any;
    caption: string;
    date: string;
    text: string;
    link?: string;
}

export type NewsData = BaseAboutUsData & {
    type: "news";
    promoted: boolean;
}

export type PeopleData = BaseAboutUsData & {
    type: "people1" | "people2" | "people3" | "people4" | "people5";
}

export type AboutUsData = NewsData | PeopleData;

export type State = "NSW" | "ACT" | "NT" | "QLD" | "TAS" | "WA" | "SA" | "VIC";

export type ContentTitle = "Why does this research need to be done?" | "How is this research being done?" | "What difference will this research make?";
export type Content = {
    title: ContentTitle,
    text: string
}

export type Focus = "Prevent" | "Treat" | "Community programs" | "Reduce harms" | "Research tools" | "Policy";

export type Researcher = {
    name: string,
    link: string
}

export type Contact = {
    name: string,
    email: string,
    subject: string
}

export type ResearchData = {
    anchor: string,
    title: string,
    theme: string,
    states: State[],
    forumId: number,
    recruiting: boolean,
    images: string[],
    content: Content[],
    publications: { id: string }[],
    focus: Focus[],
    researchers: Researcher[],
    fundingBody: string,
    contacts: Contact[]
}

export type FocusCap = "Prevent" | "Treat" | "Community Programs" | "Reduce Harms" | "Research Tools" | "Policy";

export type PublishedData = {
    type: "journals" | "reports" | "books" | "other",
    anchor: string,
    title: string,
    titleExt: string,
    publishedby: string,
    year: string,
    isResource: boolean,
    summary: string,
    link: string,
    states: State[],
    focus: FocusCap[],
    authors: string[]
}

export const menu: Link[] = [{
    name: "about us",
    route: "/AboutUs",
    children: [{
        name: "Our mission",
        route: "/Mission"
    }, {
        name: "Our Team",
        route: "/OurTeam"
    }, {
        name: "Advisory Group",
        route: "/AdvisoryGroup"
    }, {
        name: "Indigenous Advisory Group",
        route: "/IndigenousAdvisoryGroup"
    }, {
        name: "CALD Advisory Group",
        route: "/CALDAdvisoryGroup"
    }, {
        name: "Youth Advisory Group",
        route: "/YouthAdvisoryGroup"
    }, {
        name: "Consumer Advisory Group",
        route: "/ConsumerAdvisoryGroup"
    }, {
        name: "Our logo",
        route: "/OurLogo"
    },/* {
        name: "Key partners",
        route: "/Partners"
    }, */{
        name: "News",
        route: "/News"
    },]
},
{
    name: "our projects",
    route: "/Projects",
    children: [
        {
            name: "Grog Survey App",
            route: "/projectDetail",
            hash: "#grog"
        },
        {
            name: "Supporting primary care services",
            route: "/projectDetail",
            hash: "#spcs"
        },
        {
            name: "Resi rehab",
            route: "/projectDetail",
            hash: "#resi"
        },
        {
            name: "Mutual support groups",
            route: "/projectDetail",
            hash: "#msgs"
        },
        {
            name: "FASD in youth justice",
            route: "/projectDetail",
            hash: "#fasd"
        },
        {
            name: "Community responses to alcohol",
            route: "/projectDetail",
            hash: "#cra"
        },
        {
            name: "Community efforts to prevent injury",
            route: "/projectDetail",
            hash: "#cepi"
        },
        {
            name: "Involuntary treatment",
            route: "/projectDetail",
            hash: "#invol"
        },
        /*{
            name: "Forgiveness training",
            route: "/researchDetail",
            hash: "#forgive"
        },*/
        {
            name: "Prisons",
            route: "/projectDetail",
            hash: "#Prisons"
        },
        {
            name: "Alcohol use in TAFE students",
            route: "/projectDetail",
            hash: "#tafe"
        }
    ]
},/*
{
    name: "get involved",
    route: "/Involved",
    children: []
},*/
{
    name: "resources",
    route: "/Resources",
    children: []
},
/*children: [{
    name: "Public resources",
    route: "/Resources"
},
{
    name: "Member login",
    route: "/DiscussionBoard"
    }*/
//]},
{
    name: "publications",
    route: "/Publications",
    children: [
        {
            name: "Journals",
            route: "/Publications/Journals"
        },
        {
            name: "Reports",
            route: "/Publications/Reports"
        },
        {
            name: "Books",
            route: "/Publications/Books"
        },
        {
            name: "Other",
            route: "/Publications/Other"
        },
    ]
},
];

export const data: AboutUsData[] = [
    {
        type: "news",
        promoted: true,
        anchor: "10",
        title: "Sharynne Hamilton awarded Shell Aboriginal STEM Student of the Year",
        subtitle: undefined,
        img: require("./assets/img/7.0_News_10_Sharynne-Hamilton@2x.png"),
        caption: "Sharynne Hamilton and Hon.Dave Kelly (Minister for Water, Fisheries, Forestry, Innovation and ICT, Science)",
        date: "11 Oct 2019",
        text: `<p>Sharynne Hamilton, a Ngunnawal woman, was awarded the inaugural Shell Aboriginal STEM Student of the Year at the WA Premier’s Science Awards in 2019. This is a major event of National Science Week which recognises and celebrates the achievements of Western Australia’s top science, technology, engineering and mathematics (STEM) researchers and students.</p>
        <p>Sharynne is a PhD candidate with the Telethon Kids Institute and the University of Western Australia. Her research focuses on recovery and healing in young Aboriginal people. She has a background in social work and child protection research.</p>`
    },
    {
        type: "news",
        promoted: true,
        anchor: "9",
        title: "Craig Holloway awarded First Australians' Award",
        subtitle: undefined,
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_10_Holloway.png"),
        caption: "Craig Holloway",
        date: "24 June 2019",
        text: `<p><a href="https://gathering.edu.au/IndigenousAdvisoryGroup#Craig%20Holloway"><strong>Craig</strong></a> Holloway, a proud Yorta Yorta man, was awarded the First Australians' Award at the 2019 National Alcohol and Other Drugs Excellence and Innovations Awards. This is a national award recognising Craig’s leadership in improving the health and wellbeing of people with substance misuse. He has advocated with government and non-government bodies to change policy on alcohol and other drug issues in Victoria and around Australia.</p>
        <p>Craig is a manager at the Victorian Aboriginal Community Controlled Health Organisation (VACCHO) and has worked in Aboriginal alcohol and drug services for the last 22 years.</p>`
    },
    {
        type: "news",
        promoted: true,
        anchor: "8",
        title: "Grog App being refined",
        subtitle: undefined,
        img: require("./assets/img/7.0_News_8_Grog-App@2x.png"),
        caption: "Top L: Stewart Gaykamangu (Pitjantjatjara voice over artist); Melissa Thompson (Pitjantjatjara voice over artist); Stewart Gaykamangu and David Hansen (sound editor); Jimmy Perry (Aboriginal Drug and Alcohol Council SA), Kylie Lee, Stewart Gaykamangu, Michelle Fitts (La Trobe Uni), Melissa Thompson",
        date: "30 May 2019",
        text: `<p><a href="https://gathering.edu.au/researchDetail#grog"><strong>The Grog App</strong></a> – has been found to be an <a href="https://www.ncbi.nlm.nih.gov/pubmed/31039824"><strong>accurate</strong></a> and <a href="https://www.ncbi.nlm.nih.gov/pubmed/30887909"><strong>acceptable</strong></a> way to help Aboriginal and Torres Strait Islander peoples describe what they drink. The App is now being refined to include suggestions from participants, research assistants, community members and researchers. This includes updating the Pitjantjatjara audio tracks with Melissa Thompson, Stewart Gaykamangu, David Hansen (sound editor) and <a href="https://gathering.edu.au/Investigators#Jimmy%20Perry"><strong>Jimmy Perry</strong></a>. We will test drive the App again in a remote and an urban community in 2019.</p>
        <p>For questions about the App please email: <a href="mailto:kylie.lee@sydney.edu.au"><strong>kylie.lee@sydney.edu.au</strong></a>.</p>`
    },
    {
        type: "news",
        promoted: false,
        anchor: "7",
        title: "Come hear what we do at the First Symposium",
        subtitle: undefined,
        img: undefined,
        caption: undefined,
        date: "25 July 2018",
        text: `<p>The first symposium for the Centre of Research Excellence in Indigenous Health and Alcohol will showcase the work of the Centre.</p>
        <p>It will span research on preventing unhealthy alcohol use through to helping individuals who are already experiencing harms from their drinking. This includes those who are dependent on alcohol (or ‘addicted’). This work is being conducted in a range of settings from prisons through to Aboriginal and Torres Strait Islander Community Controlled Health Services.</p>
        <p>The symposium will be held at University of Sydney (Camperdown campus) on Thursday 30 August (8:30am-1:30pm).</p>
        <p>Space is limited, so please <a href="/ContactUs?type=other&msg=I%20can%20come%20to%20the%20CRE%20First%20Symposium"><strong>RSVP</strong></a> by Friday 3 August</p>
        <p>For questions about this event please email: <a href="mailto:alcohol.studies@sydney.edu.au"><strong>alcohol.studies@sydney.edu.au</strong></a>.</p>`
    },
    {
        type: "news",
        promoted: false,
        anchor: "5",
        title: "Kristie Harrison awarded a National AOD Award",
        subtitle: undefined,
        img: require("./assets/img/7.0_News_Harrison-award@2x.png"),
        caption: "Kristie Harrison",
        date: "25 Aug 2017",
        text: "Kristie Harrison, a Wiradjuri woman and PhD student of the Centre of Research Excellence in Indigenous Health and Alcohol has been awarded the National Alcohol and other Drug (AOD) First Australians Award in 2017. This award, from the Alcohol and Drug Foundation, recognises her commitment and her contribution to reducing the negative impacts of AOD use on Aboriginal and Torres Strait Islander peoples. Kristie has many years of experience supporting the Aboriginal AOD workforce in NSW. She was also the youth representative on the National Indigenous Drug and Alcohol Committee. In her PhD studies Kristie’s leadership skills have been a big help in successfully inviting more than twenty Aboriginal community controlled health services from around Australia into a trial designed to support services to work with alcohol. Kristie's  ability to communicate the research proposal clearly to frontline clinicians, and to be sensitive to the priorities and concerns of each service has been a great asset.",
        link: "/researchDetail#spcs"
    },
    {
        type: "news",
        promoted: false,
        anchor: "2",
        title: "Scott Wilson awarded Adjunct Associate Professor title from The University of Sydney",
        subtitle: undefined,
        img: require("./assets/img/7.0_News_2_Scott-Wilson@2x.png"),
        caption: "Adjunct Associate Professor Scott Wilson",
        date: "17 July 2017",
        text: "Scott Wilson has been at the forefront of policy and advocacy efforts in the Indigenous alcohol and other drugs sector for over two decades. His leadership and commitment has now been recognised with an Adjunct Associate Professor title from the University of Sydney’s Medicine Faculty. Congratulations Scott! As CEO of the Aboriginal Drug and Alcohol Council SA, Scott is a long time collaborator with the University of Sydney. He completed his Masters in Indigenous Health (Substance Use) from the School of Public Health in 2011. He was awarded the Sister Alison Bush Medal in 2012 for his outstanding contributions to the Indigenous alcohol and other drug sector in Australia and for his academic achievement. Scott is an investigator on three NHMRC-funded grants on alcohol in Indigenous Australians. "
    },
    {
        type: "news",
        promoted: false,
        anchor: "3",
        title: "Noel Hayman awarded Professor title from Griffith University",
        subtitle: undefined,
        img: require("./assets/img/7.0_News_3_Noel-Hayman@2x.png"),
        caption: "Professor Noel Hayman",
        date: "17 July 2017",
        text: "Congratulations to Noel Hayman who has been made a Professor in the School of Medicine from Griffith University. In this new role, Noel leads Griffith University’s international exchange program for Indigenous medical students. Noel already has an impressive list of achievements in the Indigenous health and primary care sectors. He was a past Queensland nomination for Australian of the Year. He heads up the Southern Queensland Centre of Excellence in Aboriginal and Torres Strait Islander Primary Health Care. Noel has also been past chair and member of several NHMRC and Royal Australian College of Physician committees."
    },
    {
        type: "news",
        promoted: true,
        anchor: "1",
        title: "Funding announcement: A Centre of Research Excellence to support Indigenous alcohol researchers",
        subtitle: undefined,
        img: require("./assets/img/7.0_News_1_Funding-Announcement@2x.png"),
        caption: "Dr Kylie Lee, Professor Chris Doran, Professor Anthony Shakeshaft, Professor Noel Hayman, Adjunct Associate Professor Scott Wilson, Professor Kate Conigrave [Absent: Professor Paul Haber, Associate Professor Rowena Ivers, Dr Anton Clifford-Motopi-Motopi]",
        date: "17 July 2017",
        text: "On 27 October 2016, The Hon. Minister Ken Wyatt announced the latest round of NHMRC funding commitments. This included a Centre of Research Excellence (CRE) to build Indigenous research capacity to find solutions to alcohol problems. This Centre brings together health service, cultural and research expertise to prevent or treat alcohol problems. It builds on years of strong relationships between the research team and community controlled health services in several states and territories of Australia. The Centre will support the recruitment and training of Aboriginal and Torres Strait Islander researchers, and will help establish a strong and ongoing network of Aboriginal and Torres Strait Islander research expertise in this field.",
        link: "http://sydney.edu.au/news-opinion/news/2016/10/27/nhmrc-funds-new-centre-for-research-excellence-in-indigenous-hea.html"
    },
    {
        type: "news",
        promoted: true,
        anchor: "4",
        title: "University of Sydney 'Radius' article features work of the Centre of Research Excellence: Indigenous Health and Alcohol",
        subtitle: undefined,
        img: require("./assets/img/7.0_News_4_Radius-article.png"),
        caption: "Professor Kate Conigrave and Adjunct Associate Professor Scott Wilson as pictured on the front cover of 'Radius'",
        date: "17 July 2017",
        text: "Scott Wilson, Kate Conigrave and Kylie Lee were interviewed by the University of Sydney's Radius magazine about their new Centre of Research Excellence in Indigenous Health and Alcohol.",
        link: "http://sydney.edu.au/medicine/alumni/radius/2017/radius-autumn-2017.pdf"
    },
    {
        type: "people1",
        anchor: "Kate Conigrave",
        title: "Professor Kate Conigrave",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_1_Conigrave.png"),
        caption: undefined,
        date: undefined,
        link: "http://sydney.edu.au/medicine/people/academics/profiles/kate.conigrave.php",
        text: "Kate is an Addiction Medicine and Public Health Physician at Royal Prince Alfred Hospital and a Conjoint Professor at the University of Sydney. She is also Co-Director of the Centre of Research Excellence in Indigenous Health and Alcohol. Her research focuses on preventing and treating alcohol and other drug problems, especially in Indigenous Australian contexts. Kate has trained health professionals for over 20 years and is an editor on two clinical handbooks. She has authored over 110 research publications. Kate has acted as consultant for the World Health Organization and has received the Senior Scientist award from the Australasian Professional Society on Alcohol and other Drugs."
    },
    {
        type: "people1",
        anchor: "Scott Wilson",
        title: "Adjunct Associate Professor Scott Wilson",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_2_Wilson.png"),
        caption: undefined,
        date: undefined,
        link: "http://www.adac.org.au/staff.php",
        text: "Scott is the CEO of the Aboriginal Drug and Alcohol Council SA (ADAC) and Adjunct Associate Professor in the Faculty of Medicine and Health at the University of Sydney. He is also Co-Director of the Centre of Research Excellence in Indigenous Health and Alcohol. Scott has served as Deputy Chair of the National Indigenous Drug and Alcohol Committee and Chair of the Alcohol Education Rehabilitation Foundation. Scott has worked with Indigenous communities nationally to develop innovative ways to prevent, treat and reduce harms from alcohol and other drug use. He has received several awards including the Australian Centenary Medal and the Sister Alison Bush Award from the University of Sydney."
    },
    {
        type: "people1",
        anchor: "Anthony Shakeshaft",
        title: "Professor Anthony Shakeshaft",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_3_Shakeshaft@2x.png"),
        caption: undefined,
        date: undefined,
        link: "https://ndarc.med.unsw.edu.au/people/professor-anthony-shakeshaft",
        text: "Anthony is Deputy Director, National Drug and Alcohol Research Centre (NDARC), UNSW. He has served on the Council of NHMRC (2012-15) and been a visiting research fellow at a number of universities in Australia and overseas. Anthony’s research focuses on developing and evaluating public health and clinical interventions that are embedded into routine practice, with a particular interest in partnering with Indigenous communities. He has led or contributed to more than 20 intervention trials, including the Alcohol Action in Rural Communities project – the largest whole-of-community cluster randomized controlled trial to reduce alcohol harms ever undertaken internationally."
    },
    {
        type: "people1",
        anchor: "Noel Hayman",
        title: "Professor Noel Hayman",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_4_Hayman@2x.png"),
        caption: undefined,
        date: undefined,
        text: "Noel was one of the first two Indigenous physicians to graduate from the University of Queensland. Noel is Clinical Director of Southern Queensland Centre of Excellence in Aboriginal and Torres Strait Islander Primary Health Care (Inala Indigenous Health Service), Associate Professor with University of Queensland and Professor with Griffith University. He has been instrumental in demonstrating how primary health services can be made appropriate to the needs of urban Indigenous populations. Noel’s interests include improving Indigenous access to health services and supporting medical education in Indigenous health. Noel was Queensland’s Australian of the Year, 2011. He won the 2003 Centenary Medal and the inaugural Close the Gap Indigenous Health Award, 2007."
    },
    {
        type: "people1",
        anchor: "Paul Haber",
        title: "Professor Paul Haber ",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_5_Haber@2x.png"),
        caption: undefined,
        date: undefined,
        link: "http://sydney.edu.au/medicine/people/academics/profiles/paul.haber.php",
        text: "Paul is Clinical Director of Drug Health Services, Sydney Local Health District and a Conjoint Professor at the University of Sydney. He authored the Australian National Alcohol Treatment Guidelines and contributed to the Alcohol Treatment Guidelines for Indigenous Australians. Paul established an alcohol and drug inpatient treatment unit in a major teaching hospital, a service model adopted by other hospitals. Paul has written over 200 research articles, reviews, book chapters, books and clinical reports. He led the largest Australian pharmacotherapy trial for alcohol dependence. He is also an investigator on a Centre of Research Excellence on mental health and substance use."
    },
    {
        type: "people1",
        anchor: "Kylie Lee",
        title: "Associate Professor Kylie Lee ",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_6_Lee.png"),
        caption: undefined,
        date: undefined,
        link: "http://sydney.edu.au/medicine/people/academics/profiles/kylie.lee.php",
        text: "Kylie is an Associate Professor in the Faculty of Medicine and Health at the University of Sydney and Deputy Director of the Centre of Research Excellence in Indigenous Health and Alcohol. She is also a Visiting Research Fellow, Centre for Alcohol Policy Research (La Trobe University). Her highly original research in alcohol and other drug use is led by community or health service requests. Kylie is lead editor on a clinical textbook requested by Indigenous alcohol and other drug workers nationally and has been invited to assist Inuit and Sri Lankan communities in knowledge translation. Her work has won national recognition including a 2011 Australian Teachers of Media Award for a film on problem drinking."
    },
    {
        type: "people1",
        anchor: "Rowena Ivers",
        title: "Associate Professor Rowena Ivers ",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_7_Ivers.png"),
        caption: undefined,
        date: undefined,
        link: "https://med.unsw.edu.au/people/dr-rowena-ivers",
        text: "Rowena is a General Practitioner at Illawarra Aboriginal Medical Service (IAMS) in New South Wales. She is a Clinical Associate Professor at the University of Wollongong and has worked in Aboriginal health for over 20 years. Her research focus includes alcohol and tobacco programs. Rowena helped establish an alcohol home detoxification pilot program at IAMS, ‘The A Clinic’. This program won the Aboriginal Drug and Alcohol Network (ADAN) Program of the Year award (2014) and NSW Health’s award for Best Program for Continuity of Care in Aboriginal health."
    },
    {
        type: "people1",
        anchor: "Chris Doran",
        title: "Professor Chris Doran",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_8_Doran.png"),
        caption: undefined,
        date: undefined,
        link: "https://handbook.cqu.edu.au/profiles/view/9457",
        text: "Chris is a Professor of health economics at Central Queensland University and has adjunct appointments at the University of Newcastle and Edith Cowan University. Chris is an international expert in the area of priority setting and is recognized as one of Australia’s leading health economists. Recently, he was involved in the largest study of preventive strategies ever undertaken that examined the cost-effectiveness of 150 preventive health interventions for non-communicable diseases, addressing areas such as obesity, mental health, tobacco use, alcohol use, nutrition, body weight and physical activity. Chris has been an investigator on 62 competitive grants, including 22 NHMRC grants."
    },
    {
        type: "people1",
        anchor: "Anton Clifford-Motopi",
        title: "Dr Anton Clifford-Motopi",
        subtitle: undefined,
        img: require("./assets/img/2.2_Chief-Investigators_9_Clifford.png"),
        caption: undefined,
        date: undefined,
        link: "https://public-health.uq.edu.au/profile/1321/anton-clifford",
        text: "Anton Clifford-Motopi is a Senior Research Fellow in the Queensland Drug and Alcohol Research Education Centre, School of Public Health at the University of Queensland. Over the past 10 years he has worked with Indigenous health services in Queensland and New South Wales to implement and evaluate strategies to enhance their delivery of best evidence alcohol interventions. He is the recipient of an ARC Early Career Researcher Award to improve alcohol prevention in Indigenous residential rehabilitation services."
    },
    {
        type: "people2",
        anchor: "Jimmy Perry",
        title: "Jimmy Perry",
        subtitle: undefined,
        img: require("./assets/img/2.3_Associate-Investigators_1_Perry.jpg"),
        caption: undefined,
        date: undefined,
        text: "Jimmy is Ngarrindjerri/Arrernte and has worked with Makin’ Tracks for the Aboriginal Drug and Alcohol Council SA for over 15 years. He is a recipient of the APSAD First Peoples award and has a Masters in Indigenous Health (Substance Use) from the University of Sydney. Jimmy is an investigator on an NHMRC grant to find better ways to measure alcohol use in Indigenous Australians."
    },
    {
        type: "people2",
        anchor: "Steve Ella",
        title: "Steve Ella ",
        subtitle: undefined,
        img: require("./assets/img/2.3_Associate-Investigators_2_Ella.png"),
        caption: undefined,
        date: undefined,
        text: "Steve is  from  the  Yuin  nation  and is  Manager  of  Nunyara  Aboriginal  Health  Unit,  Central Coast  Local  Health  District  (NSW).  He  has  worked  for  20  years  in  Aboriginal  drug  and alcohol work and was inducted into the National Indigenous Drug and Alcohol Committee’s Honour Roll in 2012."
    },
    {
        type: "people2",
        anchor: "Dennis Gray",
        title: "Professor Dennis Gray",
        subtitle: undefined,
        img: require("./assets/img/2.3_Associate-Investigators_3_Gray.png"),
        caption: undefined,
        date: undefined,
        link: "http://db.ndri.curtin.edu.au/staff/staff.asp?persid=9",
        text: "Dennis is an Adjunct Professor at the National Drug Research Institute where he was previously Deputy Director and where he led the Aboriginal Research Program for 25 years. He has worked extensively with Indigenous communities on alcohol and other drug issues, has over 90 publications in the field and has received various awards for his work."
    },
    {
        type: "people2",
        anchor: "Michael Doyle",
        title: "Dr Michael Doyle",
        subtitle: undefined,
        img: require("./assets/img/2.3_Associate-Investigators_4_Doyle.png"),
        caption: undefined,
        date: undefined,
        link: "https://kirby.unsw.edu.au/people/mr-michael-doyle",
        text: "Michael is a Bardi man (WA) and Wingara Mura Fellow at the University of Sydney. He has a particular interest in prison-based alcohol and other drug treatment, which is the topic of his PhD thesis (completed in 2018). He has extensive experience in Indigenous Australian health service delivery, policy/planning and research."
    },
    {
        type: "people2",
        anchor: "Angela Dawson",
        title: "Professor Angela Dawson",
        subtitle: undefined,
        img: require("./assets/img/2.3_Associate-Investigators_6_Dawson.png"),
        caption: undefined,
        date: undefined,
        link: "https://www.uts.edu.au/staff/angela.dawson",
        text: "Angela is a public health social scientist and qualitative research expert at UTS. Angela has over 100 publications and has written numerous reports for governments and UN agencies. She has over 20 years experience in Indigenous Australian and international primary health care workforce development, health promotion and health communication."
    },
    {
        type: "people2",
        anchor: "Timothy Dobbins",
        title: "Associate Professor Timothy Dobbins",
        subtitle: undefined,
        img: require("./assets/img/2.3_Associate-Investigators_7_Dobbins.jpg"),
        caption: undefined,
        date: undefined,
        link: "https://ndarc.med.unsw.edu.au/people/associate-professor-timothy-dobbins",
        text: "Tim is a biostatistician based at the National Drug and Alcohol Research Centre (NDARC) at UNSW. He is committed to producing high quality work that is easily understood by non-statisticians.  Tim  has  over  70  publications  and  has  previously  worked  at  the  National Centre for Epidemiology and Population Health at ANU."
    },
    {
        type: "people3",
        anchor: "Kristie Harrison",
        title: "Kristie Harrison",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_1_Harrison.png"),
        caption: undefined,
        date: undefined,
        text: "Kristie is a Wiradjuri woman undertaking a PhD at the University of Sydney. She has worked at the Illawarra Aboriginal Medical Service, Aboriginal Health and Medical Research Council and the University of Wollongong. She was also a member of the National Indigenous Drug and Alcohol Committee and a recipient of the 2017 Alcohol and Other Drug Excellence and Innovation Award. Kristie has worked primarily in Aboriginal community control and the drug and alcohol sector."
    },
    {
        type: "people3",
        anchor: "Doug James",
        title: "Doug James",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_2_James@2x.png"),
        caption: undefined,
        date: undefined,
        text: "Doug is a Wiradjuri man who is enrolled in a PhD at the National Drug and Alcohol Research Centre, UNSW. Doug has worked in Aboriginal drug and alcohol and mental health since 1990 and as a lecturer in the Djirruwang Program (Mental Health) at Charles Sturt University."
    },
    {
        type: "people3",
        anchor: "Sharynne Hamilton",
        title: "Sharynne Hamilton",
        subtitle: undefined,
        img: require("./assets/img/Unconfirmed.png"),
        caption: undefined,
        date: undefined,
        text: "Sharynne is a Ngunnawal woman and is enrolled in a PhD at University of Western Australia. A qualitative researcher with Telethon Kids Institute’s Banksia Hill Fetal Alcohol Spectrum Disorder Prevalence Study, she was the Australian National University’s first Indigenous research intern with the Regulatory Institutions Network."
    },
    {
        type: "people3",
        anchor: "Elizabeth Dale",
        title: "Elizabeth Dale",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_2_Dale.png"),
        caption: undefined,
        date: undefined,
        text: "Liz is a descendant from the Worimi Nation currently enrolled in a clinical masters in psychology and PhD at the University of Wollongong. Liz has over 12 years of experience working in non-government and clinical settings. This includes in youth and adult homelessness, couples and families counselling, mental health, drug and alcohol addiction, gambling addiction, eating disorders and intergenerational trauma."
    },
    {
        type: "people3",
        anchor: "Annalee Stearne",
        title: "Annalee Stearne ",
        subtitle: undefined,
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_6_Stearne.png"),
        caption: undefined,
        date: undefined,
        text: "Annalee, a Nyungar woman, worked for more than a decade as a research associate with the National Drug Research Institute (Curtin Uni). She is currently enrolled in a PhD program at the National Drug Research Institute. She is a recipient of the 2012 APSAD First Peoples Award and was part of the team who received a National Drug and Alcohol Award in 2006."
    },
    {
        type: "people3",
        anchor: "Bonita Byrne",
        title: "Bonita Byrne",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_3_Byrne.png"),
        caption: undefined,
        date: undefined,
        text: "Bonita is a Wiradjuri woman who is enrolled in a Masters (Research) at the National Drug and Alcohol Research Centre, UNSW. Bonita has a distinguished career in Aboriginal health. She established the Aboriginal Women’s and Domestic Violence and Sexual Assault committees in NSW and was the first Aboriginal Women’s Officer in the Premier’s Department NSW."
    },
    {
        type: "people3",
        anchor: "Gemma Khodr-Purcell",
        title: "Gemma Khodr-Purcell",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_2_Ambrose.png"),
        caption: undefined,
        date: undefined,
        text: "Gemma is a Gundungurra woman who is enrolled in a Masters of Philosophy at the University of Sydney. She has a background in health sciences and has a Bachelor of Arts majoring in Indigenous Studies from the University of New England."
    },
    {
        type: "people3",
        anchor: "Teagan Weatherall",
        title: "Teagan Weatherall",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_4_Weatherall.png"),
        caption: undefined,
        date: undefined,
        text: "Teagan is enrolled in a Master of Philosophy at the University of Sydney. In 2018 she completed a Graduate Diploma in Indigenous Health Promotion. She has worked in Indigenous health for a number of years in Sydney and remote Northern Territory; as well as in administrative and research assistant roles at the University of Sydney."
    },
    /*{
        type: "people3",
        anchor: "Beryl Garrard",
        title: "Beryl Garrard",
        subtitle: undefined,
        img: require("./assets/img/Unconfirmed.png"),
        caption: undefined,
        date: undefined,
        text: "Beryl Garrard is a Waanyi woman and is enrolled in a Master of Philosophy at Curtin University. She completed a Bachelor of Arts majoring in psychology at Edith Cowan University and a postgraduate diploma in psychology at the Queensland University of Technology."
    },*/
    {
        type: "people3",
        anchor: "Lynette Bullen",
        title: "Lynette Bullen",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_5_Bullen.png"),
        caption: undefined,
        date: undefined,
        text: "Lynette is a Wiradjuri woman currently undertaking a Health Education and Training Institute (HETI) Rural Research Capacity Building Program through NSW Health. She has worked in drug and alcohol for nearly 25 years in metropolitan, regional, rural and remote NSW. Lynette is employed at the Involuntary Drug and Alcohol Treatment Unit in Orange as a Senior Drug and Alcohol Clinician."
    },
    {
        type: "people3",
        anchor: "Taleah Reynolds",
        title: "Taleah Reynolds",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_4_Reynolds.png"),
        caption: undefined,
        date: undefined,
        text: "Taleah is a Kamilaroi woman who is an Administrative and Research Support Officer for the CRE and two other NHMRC project grants. She has worked in education and housing for a number of years in Sydney."
    },
    {
        type: "people3",
        anchor: "Summer Loggins",
        title: "Summer Loggins",
        subtitle: undefined,
        img: require("./assets/img/2.4_Students-Trainees_4_Loggins.png"),
        caption: undefined,
        date: undefined,
        text: "Summer is a Bunjalung and Gadigal woman who is enrolled in a Bachelor of Arts (Psychology) and Bachelor of Laws at Macquarie University. Summer is an Administrative and Research Support Assistant for the CRE and two other NHMRC project grants at the University of Sydney. She has previously worked in the Aboriginal drug and alcohol sector for the Aboriginal Medical Service in Redfern."
    },
    {
        type: "people4",
        anchor: "Scott Wilson2",
        title: "Adjunct Associate Professor Scott Wilson",
        subtitle: "Chair",
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_1_Wilson.png"),
        caption: undefined,
        date: undefined,
        text: "Scott is the CEO of the Aboriginal Drug and Alcohol Council SA (ADAC) and Adjunct Associate Professor in the Faculty of Medicine and Health at the University of Sydney. He is also Co-Director of the Centre of Research Excellence in Indigenous Health and Alcohol. Scott has served as Deputy Chair of the National Indigenous Drug and Alcohol Committee and Chair of the Alcohol Education Rehabilitation Foundation. Scott has worked with Indigenous communities nationally to develop innovative ways to prevent, treat and reduce harms from alcohol and other drug use. He has received several awards including the Australian Centenary Medal and the Sister Alison Bush Award from the University of Sydney."
    },
    /*{
        type: "people4",
        anchor: "Warren Miller",
        title: "Warren Miller",
        subtitle: "SA representative; shared",
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_2_Miller.png"),
        caption: undefined,
        date: undefined,
        text: "Warren is a Wirangu and Kokatha man from Ceduna and Nullabor regions. He works for Aboriginal Drug and Alcohol Council SA, coordinating the Ceduna Stepping Stones Drug and Alcohol Day Centre. He has a Masters in Indigenous Health (Substance Use) from the University of Sydney. Warren has extensive experience in remote and regional communities in prevention and clinical management approaches in drug and alcohol."
    },*/
    {
        type: "people4",
        anchor: "Jimmy Perry",
        title: "Jimmy Perry",
        subtitle: "SA representative",
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_3_Perry.jpg"),
        caption: undefined,
        date: undefined,
        text: "Jimmy is Ngarrindjerri/Arrernte and has worked with Makin’ Tracks for the Aboriginal and Drug And Alcohol Council SA for over 15 years. He is a recipient of the APSAD First Peoples award and has a Masters in Indigenous Health (Substance Use) from the University of Sydney. Jimmy is an investigator on an NHMRC grant to find better ways to measure alcohol use in Indigenous Australians. "
    },
    {
        type: "people4",
        anchor: "Nathan Deaves",
        title: "Nathan Deaves",
        subtitle: "NSW representative",
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_4_Deaves@2x.png"),
        caption: undefined,
        date: undefined,
        text: "Nathan, a Gumeah-Dharawal and Walbunga man, has worked in Aboriginal health for over a decade, specifically in drug and alcohol and mental health. He is currently Senior Manager of Social Health Services at South Coast Medical Service Aboriginal Corporation with a dedicated team of 25. Nathan aims to make a difference to improve the lives of Aboriginal communities."
    },
    {
        type: "people4",
        anchor: "Sonya Egert",
        title: "Sonya Egert",
        subtitle: "Qld representative",
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_5_Egert.png"),
        caption: undefined,
        date: undefined,
        text: "Sonya, a Nununkul Goenpul woman, works as an Aboriginal Research Officer at the Southern Queensland Centre of Excellence in Aboriginal and Torres Strait Islander Primary Health Care. Sonya co-facilitates the Inala Aboriginal and Torres Strait Islander Community Jury for Health Research and is involved in research at the service."
    },
    {
        type: "people4",
        anchor: "Craig Holloway",
        title: "Craig Holloway",
        subtitle: "Vic representative",
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_10_Holloway.png"),
        caption: undefined,
        date: undefined,
        text: "Craig Holloway is a proud Yorta Yorta man and leader in the Victorian Aboriginal Health Sector. Craig has specialised in the Victorian Aboriginal Drug and Alcohol Sector with focus on service and policy reform for over 20 years. Craig is the Director, Workforce and Wellbeing at the Victorian Aboriginal Community Controlled Health Organisation (VACCHO)."
    },
    {
        type: "people4",
        anchor: "Annalee Stearne2",
        title: "Annalee Stearne ",
        subtitle: "NT/WA representative",
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_6_Stearne.png"),
        caption: undefined,
        date: undefined,
        text: "Annalee, a Nyungar woman, worked for more than a decade as a research associate with the National Drug Research Institute (Curtin Uni). She is currently enrolled in a PhD program at the National Drug Research Institute. She is a recipient of the 2012 APSAD First Peoples Award and was part of the team who received a National Drug and Alcohol Award in 2006."
    },
    {
        type: "people4",
        anchor: "Elizabeth Dale",
        title: "Elizabeth Dale",
        subtitle: "PhD representative",
        img: require("./assets/img/2.4_Students-Trainees_2_Dale.png"),
        caption: undefined,
        date: undefined,
        text: "Liz is a descendant from the Worimi Nation currently enrolled in a clinical masters in psychology and PhD at the University of Wollongong. Liz has over 12 years of experience working in non-government and clinical settings. This includes in youth and adult homelessness, couples and families counselling, mental health, drug and alcohol addiction, gambling addiction, eating disorders and intergenerational trauma."
    },
    {
        type: "people5",
        anchor: "Michael Doyle2",
        title: "Dr Michael Doyle",
        subtitle: undefined,
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_9_Doyle.png"),
        caption: undefined,
        date: undefined,
        text: "Michael is a Bardi man (WA) and Wingara Mura Fellow at the University of Sydney. He has a particular interest in prison-based alcohol and other drug treatment, which is the topic of his PhD thesis (completed in 2018). He has extensive experience in Indigenous Australian health service delivery, policy/planning and research."
    },
    {
        type: "people5",
        anchor: "Peter Malouf",
        title: "Dr Peter Malouf",
        subtitle: undefined,
        img: require("./assets/img/2.6_Indigenous-Advisory-Group_9_Malouf.jpg"),
        caption: undefined,
        date: undefined,
        text: "Peter is a Wulli Wulli/Wakka Wakka man from Queensland. He has worked in Aboriginal and Torres Strait Islander health for over 12 years in government and universities. He recently completed his PhD examining alcohol use and related harms among Indigenous and non-Indigenous university students. Peter has a Bachelor of Health Science, Master of Public Health and Grad Dip Public Health and Tropical Medicine."
    },
    {
        type: "people5",
        anchor: "Anne-Marie Eades",
        title: "Dr Anne-Marie Eades",
        subtitle: undefined,
        img: require("./assets/img/2.5_Early-Career_1_Eades@2x.png"),
        caption: undefined,
        date: undefined,
        text: "Anne-Marie is a Noongar woman from WA. Her traditional country is Minang Kaenang. She is a Registered Nurse and has her (research) Masters in Nursing. In 2018 she was awarded her PhD for a thesis on chronic disease in Aboriginal communities. Anne has a particular interest in women’s issues and child protection."
    },
];

export const researchData: ResearchData[] = [
    {
        anchor: 'grog',
        title: "Grog Survey App",
        theme: "research-banner-1 base1-bg",
        states: [
            "SA",
            "QLD"
        ],
        forumId: undefined,
        recruiting: false,
        images: [
            require("./assets/img/3.2_Our-Research_Grog-Survey-App_image.png")
        ],
        content: [
            {
                title: "Why does this research need to be done?",
                text: "This study will develop and test an iPad app designed to make it easier for Indigenous Australians to report on their drinking. When governments decide how to fund alcohol treatment or prevention programs, they look at how common a problem is. But there is no good data available on drinking among Indigenous Australians. Some experts say that the published data is ‘out’ by more than 700%. Communities and health services also do not have a good way of monitoring how well they are going with efforts to prevent or treat alcohol problems."
            },
            {
                title: "How is this research being done?",
                text: `<p>The Grog Survey App is being created with Indigenous health services, communities, health professionals and researchers. It will allow a person to choose pictures of the type of alcohol they drink, the container they use, and how full the container is with grog. The app will 'read out'  the questions in English or an Aboriginal language.</p>   
                    <p>We will test how good a job the app does. How easy it is to use? Does the App give us the same findings as when a clinician asks the same person about their drinking? Each participant will also go through the App two times (2-7 days apart) to see if results change much over time. </p>`
            },
            {
                title: "What difference will this research make?",
                text: "The finished app will be refined, tested in other communities and then made freely available to Indigenous health services and communities. The app will allow communities, health services and governments to collect better information about drinking, to inform local programs and priorities. "
            }
        ],
        publications: [
            { id: 'journals19' },
            { id: 'journals17' },
            { id: 'journals16' },
            { id: 'journals15' },
            { id: 'journals11' },
            { id: 'journals9' }
        ],
        focus: [
            "Research tools"
        ],
        researchers: [
            { name: "Kate Conigrave", link: "/Investigators#Kate%20Conigrave" },
            { name: "Kylie Lee", link: "/Investigators#Kylie%20Lee" },
            { name: "Robin Room", link: "http://www.capr.edu.au/about-us/our-people/professor-robin-room/" },
            { name: "Tanya Chikritzhs", link: "http://db.ndri.curtin.edu.au/staff/staff.asp?persid=4" },
            { name: "Noel Hayman", link: "/Investigators#Noel%20Hayman" },
            { name: "Dennis Gray", link: "/Investigators#Dennis%20Gray" },
            { name: "Ted Wilkes", link: "http://db.ndri.curtin.edu.au/staff/staff.asp?persid=229" },
            { name: "Scott Wilson", link: "/Investigators#Scott%20Wilson" },
            { name: "Sarah Callinan", link: "http://www.capr.edu.au/about-us/our-people/sarah-callinan/" },
            { name: "Tim Slade", link: "https://comorbidity.edu.au/people/aprof-tim-slade" },
            { name: "Jimmy Perry", link: "/IndigenousAdvisoryGroup#Jimmy%20Perry" }
        ],
        fundingBody: "<a target='_blank' href='http://www.nhmrc.gov.au/'>NHMRC</a> Project Grant ID #1087192 (2015-2020)",
        contacts: [{ name: "Kylie Lee", email: "kylie.lee@sydney.edu.au", subject: "Question about the Grog Survey App project" }]
    },
    {
        anchor: 'spcs',
        title: "Supporting primary<br/>care services",
        theme: "research-banner-2 base2-bg",
        states: [
            "NSW",
            "SA",
            "QLD",
            "NT",
            "VIC",
            "WA"
        ],
        forumId: 3,
        recruiting: false,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: "The study will provide a model for how to support Aboriginal and Torres Strait Islander (Indigenous) primary care services to give the best possible care for unhealthy drinking within their communities. Drinking problems have a big impact on families and communities. People who drink even a little above recommended limits (2 drinks per day) can also have a greater risk of cancer and other medical and mental health problems. In primary care services (Indigenous and mainstream), unhealthy drinking is not talked about or treated as much as smoking. Staff may feel less comfortable talking about alcohol and not confident in using alcohol treatments (like medicines to help a person stay dry, or to treat withdrawal). "
            },
            {
                title: "How is this research being done?",
                text: `<p>We will test an approach to support Indigenous primary care services to do the best they can to help people with unhealthy alcohol use. Approaches will be led by the services and guided by the evidence base. Twenty-two (22) primary care services around Australia have been invited to take part.</p><p>Around half the services (randomly selected) will receive support over eighteen months to improve the way their service works with alcohol use – ‘early support’ services. The others services will wait to get this support at the end of the study – ‘late support’ services. We will compare whether the support makes a difference in the rate at which services screen for unhealthy drinking, and the rate with which they provide help for unhealthy drinking.</p>`
            },
            {
                title: "What difference will this research make?",
                text: "The study should provide a model for how to support Indigenous primary care services to give the best possible care for unhealthy drinking within their communities. Staff of services that take part will gain in confidence in this field. Services that take part will be supported to help their clients work towards a healthier approach to drinking."
            }
        ],
        publications: [{ id: "journals190" }],
        focus: [
            "Treat",
            "Prevent",
            "Reduce harms"
        ],
        researchers: [
            { name: "Kate Conigrave", link: "/Investigators#Kate%20Conigrave" },
            { name: "Paul Haber", link: "/Investigators#Paul%20Haber" },
            { name: "Noel Hayman", link: "/Investigators#Noel%20Hayman" },
            { name: "Kylie Lee", link: "/Investigators#Kylie%20Lee" },
            { name: "Rowena Ivers", link: "/Investigators#Rowena%20Ivers" },
            { name: "Tim Dobbins", link: "https://ndarc.med.unsw.edu.au/people/associate-professor-timothy-dobbins " },
            { name: "Dennis Gray", link: "/Investigators#Dennis%20Gray" },
            { name: "David Johnson", link: "http://ahcsa.org.au/" },
            { name: "Scott Wilson", link: "/Investigators#Scott%20Wilson" }
        ],
        fundingBody: "<a target='_blank' href='http://www.nhmrc.gov.au/'>NHMRC</a> Project Grant (ID#1105339; 2016-2021)",
        contacts: [
            { name: "Kristie Harrison, PhD student", email: "kristie.harrison@sydney.edu.au", subject: "Question about the supporting primary care services project" },
            { name: "Gemma Khodr-Purcell, MPhil student", email: "gemma.khodr@sydney.edu.au", subject: "Question about the supporting primary care services project" },]
    },
    {
        anchor: 'resi',
        title: "Resi rehab",
        theme: "research-banner-3 base3-bg",
        states: [
            "NSW"
        ],
        forumId: undefined,
        recruiting: false,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: `<p>This project is being done in partnership with the seven Aboriginal residential rehabilitation services in New South Wales. It aims to improve their ability to measure treatment effectiveness and define what is a good outcome. There is very little evidence on outcomes from residential rehabilitation services in Australia. This also means there is poor data to guide quality improvement initiatives. What defines a good outcome is not limited to alcohol abstinence, but should also mesh with Indigenous priorities. This includes restored family cohesion and an increase in quality of life and social capital in Aboriginal communities. </p><p> Positive outcomes can also include better links with care for mental or physical health needs. It is anticipated that the research will also underpin the development and implementation of standardised culturally appropriate clinical tools to be used across the sector.</p>`
            },
            {
                title: "How is this research being done?",
                text: `Based on pilot work conducted at Orana Haven (NSW), this study will be expanded to include all seven Indigenous residential alcohol rehabilitation settings in NSW (four in urban areas and three in rural/regional NSW).
                The work will comprise the following steps: 
                <ul> 
                <li>A literature review to ascertain what evidence exists about the effectiveness of Indigenous residential treatment services internationally</li> 
                <li>Describe existing data collection processes in the seven Indigenous residential rehabilitation services and define what is a ‘good outcome’ (from patient or service perspectives). The tools that are used to measure those outcomes and their cost effectiveness will be described</li> 
                <li>Describe client characteristics (e.g. severity of alcohol use disorder, key physical and mental health comorbidities, social problems and quality of life indicators)</li> 
                <li>The therapeutic program used will be documented and process measures collected</li> 
                <li>Focus groups will be conducted with staff and clients</li></ul>`
            },
            {
                title: "What difference will this research make?",
                text: "This project will be the first of its kind to provide a structure for Aboriginal rehabilitation units to document their programs, and to develop and apply culturally relevant outcome measures. This study will allow us to examine what aspects of treatment appear most effective both from the perspective of the client, of the Indigenous residential rehabilitation sector and of a cost benefit analysis. The core aspects of those successful elements will then be trialled across multiple services and tailored to local needs."
            },
        ],
        publications: [{ id: "journals18100701" }],
        focus: [
            "Treat",
            "Reduce harms"
        ],
        researchers: [
            { name: "Doug James", link: "/StudentsAndTrainees#Doug%20James" },
            { name: "Norm Henderson", link: "http://www.oranahaven.com.au/OranaHaven/Home.htm" },
            { name: "Anthony Shakeshaft", link: "/Investigators#Anthony%20Shakeshaft" },
            { name: "Kylie Lee", link: "/Investigators#Kylie%20Lee" },
            { name: "Ryan Courtney", link: "https://ndarc.med.unsw.edu.au/people/dr-ryan-courtney" },
            { name: "Alice Munro", link: "https://ndarc.med.unsw.edu.au/people/ms-alice-munro" },
        ],
        fundingBody: "<a target='_blank' href='http://www.nhmrc.gov.au/'>NHMRC</a> Project Grant ID # 1117198 (2017-2022)",
        contacts: [{ name: "Doug James, PhD student", email: "d.b.james@student.unsw.edu.au", subject: "Question about the resi rehab project" }]
    },
    {
        anchor: 'msgs',
        title: "Mutual support groups",
        theme: "research-banner-4 base2-bg",
        states: [
            "NSW"
        ],
        forumId: undefined,
        recruiting: false,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: "Mutual support groups have been recognised as important tools for mobilising recovery for alcohol and other substance use disorders. These groups include the 12-step approaches (e.g. Alcoholics Anonymous) and SMART Recovery. SMART Recovery is based on the principles of cognitive behavioural therapy and motivational interviewing. In Australia, there are over 250 SMART Recovery groups, with an average of six people attending the groups. More than four in ten of these participants identify alcohol as their primary problem. Limited research has been conducted on SMART Recovery in the context of Aboriginal and Torres Strait Islander Australians. This mixed methods study will examine the experience of SMART Recovery participants and the suitability of this approach for Aboriginal and Torres Strait Islander Australians."
            },
            {
                title: "How is this research being done?",
                text: "“Decolonising Addiction Recovery Mutual Aid: Re-Knowing, Re-Being, Re-Doing”: This study will be completed as a series of smaller studies beginning with a systematic literature review to identify the use of addiction recovery mutual support groups in an Indigenous context. This will be followed by an ethnographic study to observe how SMART Recovery groups operate across Australia. The third study will consist of qualitative interviews with SMART Recovery members. Interviews will help construct narratives of lived experiences of recovery and the impact of mutual support involvement especially in Aboriginal and Torres Strait Islander participants. The final study will use the Delphi method to survey a panel of experts who will evaluate the current SMART recovery service model and accompanying resources for cultural compatibility."
            },
            {
                title: "What difference will this research make?",
                text: "This study will be conducted in collaboration with SMART Recovery Australia and is the first of its kind to examine SMART Recovery group involvement in a qualitative and ethnographic approach. It will also be the first study to examine the use of SMART Recovery in Aboriginal and Torres Strait Islander Australians."
            }
        ],
        publications: undefined,
        focus: [
            "Treat",
            "Community programs",
            "Reduce harms"
        ],
        researchers: [
            {
                name: "Elizabeth Dale",
                link: "/StudentsAndTrainees#Elizabeth%20Dale"
            },
            {
                name: "Peter Kelly",
                link: "https://scholars.uow.edu.au/display/peter_kelly"
            },
            {
                name: "Kathleen Clapham",
                link: "https://scholars.uow.edu.au/display/kathleen_clapham"
            },
            {
                name: "Rowena Ivers",
                link: "/Investigators#Rowena%20Ivers"
            },
            {
                name: "Kylie Lee",
                link: "/Investigators#Kylie%20Lee"
            },
        ],
        fundingBody: "University of Wollongong<br /><a target='_blank' href='http://www.nhmrc.gov.au/'>NHMRC</a> ID #1117198 (2017-2022)",
        contacts: [
            {
                name: "Elizabeth Dale, PhD student",
                email: "egd80@uowmail.edu.au",
                subject: "Question about the Mutual Support Groups project"
            }
        ]
    },
    {
        anchor: 'fasd',
        title: "FASD in youth justice",
        theme: "research-banner-5 base2-bg",
        states: [
            "WA"
        ],
        forumId: undefined,
        recruiting: false,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: "Children and youth who are exposed to alcohol in-utero have an increased likelihood of Fetal Alcohol Spectrum Disorder (FASD). Currently, there are no studies in Australia that examine the experiences of young people with FASD in youth justice. As a result, we do not know the ideal intervention points for diverting these young people from getting in trouble with the law when they have a neurodevelopmental disability (such as FASD). This study will examine the complex needs of young people in detention and help to identify earlier intervention points."
            },
            {
                title: "How is this research being done?",
                text: "As part of a FASD prevalence study of a detention centre in Western Australia, interviews were conducted between 2015-2017 with sentenced youth, their parents and family members, non-custodial staff and youth justice staff in the community. This qualitative data will be analysed and the major themes identified and triangulated. To aid the researcher with decolonising methodologies, the researcher will be guided by an Aboriginal Reference Group from urban, regional and remote Western Australia."
            },
            {
                title: "What difference will this research make?",
                text: "This study will be the first qualitative study to explore the experiences of youth who have undergone FASD assessment in youth detention centres. The results from this study will help inform future service delivery in Australian youth justice system."
            }
        ],
        publications: [
            { id: "journals20" },
            { id: "journals18" },
            { id: "journals14" },
            { id: "journals12" },
            { id: "journals13" },
        ],
        focus: [
            "Prevent",
            "Treat",
            "Reduce harms",
            "Policy"
        ],
        researchers: [
            {
                name: "Sharynne Hamilton",
                link: "/StudentsAndTrainees#Sharynne%20Hamilton"
            },
            {
                name: "Carol Bower",
                link: "https://www.telethonkids.org.au/contact-us/our-people/b/carol-bower/"
            },
            {
                name: "Melissa O’Donnell",
                link: "https://www.telethonkids.org.au/contact-us/our-people/o/dr-melissa-odonnell/"
            },
            {
                name: "Raewyn Mutch",
                link: "http://www.fasdcare.org.au/dr-raewyn-mutch/"
            },
            {
                name: "Tracy Reibel",
                link: "https://www.telethonkids.org.au/contact-us/our-people/r/tracy-reibel/"
            },
            {
                name: "Valerie Braithwaite",
                link: "https://researchers.anu.edu.au/researchers/braithwaite-va"
            }
        ],
        fundingBody: "Telethon Kids Institute",
        contacts: [
            {
                name: "Sharynne Hamilton",
                email: "Sharynne.Hamilton@telethonkids.org.au",
                subject: "Question about the FASD in Youth Justice project"
            }
        ]
    },
    {
        anchor: 'cra',
        title: "Community responses to alcohol",
        theme: "research-banner-1 base1-bg",
        states: [
            "NT"
        ],
        forumId: undefined,
        recruiting: true,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: "Northern Territory (NT) residents experience significant levels of alcohol-related harm. There have been many responses to address alcohol, from a community level through to initiatives led by the federal government. Given that Aboriginal people comprise more than a quarter (26.7%) of the NT population, whether intentionally or unintentionally, alcohol policies from all levels of government have targeted Aboriginal peoples in the NT. Often these policies ignore or undermine community-led responses, despite the evidence for the effectiveness of such community-driven action. There has been little or no recognition of the efforts and approaches that Aboriginal communities have taken to respond to alcohol issues and how these can contribute to more effective overall strategies."
            },
            {
                title: "How is this research being done?",
                text: `<p>This research will embed a culturally safe process to ensure transparency and accountability. It will work closely with local Aboriginal community leaders and researchers. This includes convening an Aboriginal Community Reference Group, which will include key Aboriginal people from NT who will provide guidance throughout the project.</p>   
                    <p>This research has three components:</p>
                    <ol>
                    <li>A systematic review of existing theories of community change as relevant to reduction of alcohol-related harm.</li>
                    <li>A timeline of alcohol policies in NT since 1978 with a focus on their context.</li>
                    <li>Interviews with stakeholders to prepare a series of case studies of community responses to alcohol harms, and to contribute to a framework for quality practice to addressing alcohol-related harms in Aboriginal communities.</li>
                    </ol>`
            },
            {
                title: "What difference will this research make?",
                text: "This research will give a voice to Aboriginal communities in NT to share their experiences and expertise in identifying challenges and designing and implementing effective local responses to alcohol-related harms. It will also develop an evidence-based framework to help develop and implement policies designed to bring about change at the Aboriginal community-level."
            }
        ],
        publications: undefined,
        focus: [
            "Prevent",
            "Treat",
            "Community programs",
            "Reduce harms",
            "Policy"
        ],
        researchers: [
            { name: "Annalee Stearne", link: "/StudentsAndTrainees#Annalee%20Stearne" },
            { name: "Steve Allsop", link: "http://ndri.curtin.edu.au/people/profile/105" },
            { name: "Michael Wright", link: "https://www.telethonkids.org.au/contact-us/our-people/w/michael-wright/" },
            { name: "Anthony Shakeshaft", link: "/Investigators#Anthony%20Shakeshaft" },
        ],
        fundingBody: undefined,
        contacts: [{ name: "Annalee Stearne", email: "annalee.stearne@postgrad.curtin.edu.au", subject: "Question about the community responses to alcohol research project" }]
    },
    {
        anchor: "cepi",
        title: "Community efforts<br/>to prevent injury",
        theme: "research-banner-6 base1-bg",
        states: [
            "NSW"
        ],
        forumId: undefined,
        recruiting: false,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: `This study is looking at a range of community actions to prevent alcohol harms in two communities in New South Wales. The intervention has three standardised core components that will allow it to be implemented elsewhere if shown to be effective: 1) Community engagement and alcohol harm prevention activities 2) Improved alcohol treatment services and 3) Empowerment of Indigenous Australians.`
            },
            {
                title: "How is this research being done?",
                text: "The researcher (Byrne) will continue to facilitate the intervention for a further 2 years (2017 and 2018) in Narrandera and will extend the intervention to at least one other (NSW) community. This will include consultation with the whole of the community, focusing mainly on the local Aboriginal community. Community events will be conducted inviting Aboriginal people of all ages and backgrounds to participate. The scope and intervention conducted will depend on the availability of funds, facilities and participation of the community. A number of efforts have been made to engage the community in this research. This research/prevention project will consult and engage service providers from every area, including Aboriginal organisations, government and non-government departments. It is anticipated that a committee representing the local Aboriginal people involved in the study will be established to help guide the research."
            },
            {
                title: "What difference will this research make?",
                text: "This project will document what communities themselves can do at relatively low cost to prevent or address alcohol problems. It would be the first project set in an Aboriginal community to examine the effectiveness of an integrated, multi-pronged approach."
            },
        ],
        publications: undefined,
        focus: [
            "Prevent",
            "Community programs",
            "Reduce harms"
        ],
        researchers: [
            { name: "Bonita Byrne", link: "/StudentsAndTrainees#Bonita%20Byrne" },
            { name: "Mieke Snijder", link: "https://ndarc.med.unsw.edu.au/people/ms-mieke-snijder" },
            { name: "Anthony Shakeshaft", link: "/Investigators#Anthony%20Shakeshaft" },
        ],
        fundingBody: "<a target='_blank' href='http://www.nhmrc.gov.au/'>NHMRC</a> Project Grant ID # 1117198 (2017-2022)",
        contacts: [{ name: "Bonita Byrne, Masters (research) student", email: "b.byrne@unsw.edu.au", subject: "Question about the community efforts to prevent injury project" }]
    },
    {
        anchor: 'invol',
        title: "Involuntary treatment",
        theme: "research-banner-2 base2-bg",
        states: [
            "NSW"
        ],
        forumId: undefined,
        recruiting: false,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: "Involuntary treatment can give some people time to step back and decide what they want to do with their drinking. Since the repeal of the Inebriates Act in 2012, there has been a reduction in admissions of Aboriginal people into the Involuntary Drug and Alcohol Treatment (IDAT) Unit at Orange Health Service. Yet alcohol attributable hospitalisations are significantly higher in Aboriginal Australians compared with their non-Indigenous counterparts."
            },
            {
                title: "How is this research being done?",
                text: "Lynette will interview NSW Health drug and alcohol clinicians about the perceived barriers and enablers to referring an Aboriginal person to IDAT. Interviews will be transcribed and thematically analysed."
            },
            {
                title: "What difference will this research make?",
                text: "Understanding the clinicians’ perspective can help assess the reasons why IDAT admissions are low for Aboriginal Australians. It will also help us understand how to address misconceptions regarding IDAT referrals and admissions."
            },
        ],
        publications: undefined,
        focus: [
            "Treat",
            "Reduce harms",
            "Policy",
        ],
        researchers: [
            { name: "Lynette Bullen", link: "/StudentsAndTrainees#Lynette%20Bullen" },
            { name: "Kylie Lee", link: "/Investigators#Kylie%20Lee" },
            { name: "Alice Munro", link: "https://ndarc.med.unsw.edu.au/people/ms-alice-munro" },
            { name: "Angela Dawson", link: "/Investigators#Angela%20Dawson" },
        ],
        fundingBody: "NSW Health Health Education Training Institute (HETI)",
        contacts: [{ name: "Lynette Bullen", email: "lynette.bullen@health.nsw.gov.au", subject: "Question about the involuntary treatment project" }]
    },
    /*{
        anchor: 'forgive',
        title: "Forgiveness training",
        theme: "research-banner-1 base1-bg",
        states: [
            "WA"
        ],
        forumId: undefined,
        recruiting: false,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: `<p>Counselling is a common treatment for alcohol use disorders but there is limited research on effective and culturally appropriate counselling approaches for Indigenous Australians. Forgiveness training is a program that may help respond to alcohol use disorders, potentially reducing the risk of relapse.</p>`
            },
            {
                title: "How is this research being done?",
                text: `This research is divided into three phases:
                <ul> 
                <li>Literature review on the role of forgiveness training in improving social and emotional wellbeing</li> 
                <li>Consultations with Aboriginal and Torres Strait Islander drug and alcohol workers and other staff who work with Indigenous Australian clients at three key services in WA. Consultations will include a review of treatment protocols to identify current treatment strategies, the perceived role of forgiveness approaches in recovery and staff perception of the potential value of Forgive to Live.</li>
                <li>Interviews with Aboriginal participants who have a past history of alcohol and drug use disorders from among clients, students or staff of these three key services to identify their experience of treatment, the role of forgiveness in the process of recovery and the potential role of Forgive to Live approaches.</li> 
                </ul>`
            },
            {
                title: "What difference will this research make?",
                text: "This research will identify whether the Forgive to Live program can be acceptable for use with Aboriginal and Torres Strait Islander peoples."
            },
        ],
        publications: undefined,
        focus: [
            "Treat",
            "Reduce harms"
        ],
        researchers: [
            { name: "Beryl Garrard", link: "/StudentsAndTrainees#Beryl%20Garrard" },
            { name: "Steve Allsop", link: "http://ndri.curtin.edu.au/people/profile/105" },
            { name: "Mandy Wilson", link: "https://research.curtin.edu.au/supervisor/dr-mandy-wilson/" },
            { name: "Kate Conigrave", link: "/Investigators#Kate%Conigrave" },
        ],
        fundingBody: "",
        contacts: [{
            name: "Beryl Garrard", email: "beryl.garrard@postgrad.curtin.edu.au", subject: ""
        }]
    },*/
    {
        anchor: "prisons",
        title: "Prisons",
        theme: "research-banner-7 base2-bg",
        states: [
            "NSW"
        ],
        forumId: undefined,
        recruiting: false,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: "Aboriginal and Torres Strait Islander (Indigenous) Australians are over-represented in Australian prisons. Many inmates (Indigenous and non-Indigenous) have a history of alcohol or drug use. Michael’s PhD research examined experiences of 31 Indigenous and non-Indigenous men who had undertaken prison-based alcohol and other drug treatment. This is likely to be the first time that qualitative research of this kind has been conducted internationally by an Indigenous researcher. The next phase aims to further develop an understanding of the treatment needs of Indigenous inmates, and to work towards testing an approach to help inmates reduce the harms from alcohol when they leave prison. "
            },
            {
                title: "How is this research being done?",
                text: "This research will use qualitative and quantitative methods. The collaborative approach used in Michael’s PhD will continue with key stakeholders, including: Aboriginal community controlled health services, departments responsible for the administration of prisons, and the relevant health service providers for prisons in each jurisdiction."
            },
            {
                title: "What difference will this research make?",
                text: "The published research in this field is sparse; particularly as relates to Indigenous peoples internationally.  This research will make a significant contribution to the knowledge base.  "
            },
        ],
        publications: [{ id: "journals7" }],
        focus: [
            "Prevent",
            "Community programs",
            "Reduce harms",
            "Policy"
        ],
        researchers: [
            { name: "Michael Doyle", link: "/Investigators#Michael%20Doyle" },
            { name: "Kate Conigrave", link: "/Investigators#Kate%20Conigrave" },
        ],
        fundingBody: "Michael holds a Wingara Mura Fellowship, from the University of Sydney",
        contacts: [{ name: "Michael Doyle", email: "michael.doyle@sydney.edu.au", subject: "Question about the prisons project" }]
    },
    {
        anchor: 'tafe',
        title: "Alcohol use in TAFE students",
        theme: "research-banner-1 base1-bg",
        states: [
            "QLD"
        ],
        forumId: undefined,
        recruiting: true,
        images: undefined,
        content: [
            {
                title: "Why does this research need to be done?",
                text: "There is very little research on cultural variations within vocational education settings, in relation to alcohol consumption and alcohol-related harm. However, anecdotal evidence suggests that young people enrolled at TAFE are more likely to consume harmful levels of alcohol than same-aged peers who are not at TAFE, and that this alcohol consumption results in risky behaviour and a range of consequent. The purpose of this study is to examine the prevalence and patterns of alcohol use among TAFE students, for Indigenous Australian and non-Indigenous students."
            },
            {
                title: "How is this research being done?",
                text: `<p>This research aims to assess three potential harms from alcohol: physical harm, academic performance and mental health (depression).</p>   
                    <p>A student reference group (consisting of Indigenous and non-Indigenous students) will be established to provide advice on data collection and dissemination of results. The study will utilise both hard-copy and online data collection methods to survey TAFE students between the age of 17 to 24.</p>
                    <p>Following the data collection, analysis will be described by three objectives separately:</p>
                    <ul>
                    <li>Objective 1: Examine the prevalence and patterns of alcohol consumption.</li>
                    <li>Objective 2: Examine the association between patterns of alcohol consumption and the three dimensions of alcohol-related harm.</li>
                    <li>Objective 3: Determine whether there are cultural variations in the association between patterns of alcohol consumption and alcohol-related harm in this cohort (between Indigenous and non-Indigenous students).</li>
                    </ul>
                    <p>A group of enrolled Indigenous health workers (in HLTAHW023 Plan, develop and evaluate health promotion and community development programs) will also be invited to review the results and develop health promotion programs to fulfil their subject requirements.</p>`
            },
            {
                title: "What difference will this research make?",
                text: "The study will provide information and insights on behavioural factors that need to be considered for effective strategies and interventions to be designed to promote awareness of alcohol and alcohol-related harms in Indigenous Australian TAFE students."
            }
        ],
        publications: undefined,
        focus: [
            "Prevent",
            "Reduce harms"
        ],
        researchers: [
            { name: "Peter Malouf", link: "/EarlyCareer#Peter%20Malouf" }
        ],
        fundingBody: undefined,
        contacts: [{ name: "Peter Malouf", email: "pmalouf@uow.edu.au", subject: "Question about the alcohol use in TAFE students research project" }]
    },
];

export const publishedData: PublishedData[] = [
    {
        type: "journals",
        anchor: 'journals20',
        title: "Disability “In-Justice”: The Benefits and Challenges of “Yarning” With Young People",
        titleExt: " Undergoing Diagnostic Assessment for Fetal Alcohol Spectrum Disorder in a Youth Detention Center",
        publishedby: "Qualitative Health Research",
        year: "2019",
        isResource: false,
        summary: "This research assessed the benefits and challenges of “yarning” (an Indigenous research method which allows for data collection in an exploratory, culturally safe way) as a data collection tool. Interviews were conducted with participants at a youth detention centre in Western Australia using “social yarning” and “research topic yarning” to assess their experience of an in-depth clinical interview. The authors conclude that “yarning” as a data collection tool could benefit children and young people undergoing neurodevelopmental assessments.",
        link: "https://journals.sagepub.com/doi/10.1177/1049732319882910",
        states: [
            "WA",
        ],
        focus: [
            "Research Tools",
        ],
        authors: [
            "Sharynne Hamilton",
            "Tracy Reibel",
            "Sarah Maslen",
            "Rochelle Watkins",
            "Freeman Jacinta",
            "Hayley Passmore",
            "Raewyn Mutch",
            "Melissa O’Donnell",
            "Valerie Braithwaite",
            "Carol Bower",
        ],
    },
    {
        type: "journals",
        anchor: 'journals19',
        title: "Short screening tools for risky drinking",
        titleExt: " in Aboriginal and Torres Strait Islander Australians: modified AUDIT-C and a new approach",
        publishedby: "Addiction Science & Clinical Practice",
        year: "2019",
        isResource: false,
        summary: "This study looks at how well short alcohol screening tools (like AUDIT-C modified and the Finnish method) can detect risky drinking, using the Grog Survey App. The study showed that AUDIT-Cm has a higher sensitivity in detecting risky drinking compared with the Finnish method. The combination of AUDIT-1m and AUDIT-2m was able to classify the drinking risk status for all but four individuals in the same way as the Finnish method did. Regarding the Finnish method, assessing the last two occasions and timing of last four occasions may be a more practical short screening tool than the full Finnish method. ",
        link: "https://ascpjournal.biomedcentral.com/articles/10.1186/s13722-019-0152-6",
        states: [
            "QLD",
            "SA",
        ],
        focus: [
            "Research Tools",
        ],
        authors: [
            "Kylie Lee",
            "James Conigrave",
            "Scott Wilson",
            "Jimmy Perry",
            "Sarah Callinan",
            "Robin Room",
            "Tanya Chikritzhs",
            "Tim Slade",
            "Noel Hayman",
            "Geoffrey Leggat",
            "Kate Conigrave",
        ],
    },
    {
        type: "journals",
        anchor: 'journals18',
        title: "‘He has problems; he is not the problem…’ A qualitative study",
        titleExt: " of non-custodial staff providing services for young offenders assessed for Foetal Alcohol Spectrum Disorder in an Australian youth detention centre",
        publishedby: "Youth Justice",
        year: "2019",
        isResource: false,
        summary: "Aboriginal young people are significantly over-represented in youth detention facilities, comprising 54% despite being only 3% of the population. This qualitative study undertaken with non-custodial staff described their perspectives on the value and impact of a foetal alcohol spectrum disorder (FASD) prevalence study. Study participants generally deemed assessments for young people in detention to be beneficial. Staff also highlighted the limitations of the workforce to support young people living with FASD, including a lack of professional development opportunities, resources and staff.",
        link: "https://journals.sagepub.com/doi/10.1177/1473225419869839",
        states: [
            "WA",
        ],
        focus: [
            "Community Programs",
            "Reduce Harms",
        ],
        authors: [
            "Sharynne Hamilton",
            "Tracy Reibel",
            "Rochelle Watkins",
            "Raewyn Mutch",
            "Natalie Kippin",
            "Jacinta Freeman",
            "Hayley Passmore",
            "Bernadette Safe",
            "Melissa O’Donnell",
            "Carol Bower",
        ],
    },
    {
        type: "journals",
        anchor: 'journals17',
        title: "Patterns of drinking in Aboriginal and Torres Strait Islander peoples",
        titleExt: " as self-reported on the Grog Survey App: a stratified sample",
        publishedby: "BMC Medical Informatics and Decision Making",
        year: "2019",
        isResource: false,
        summary: "The Grog Survey App is an interactive tablet computer-based application that can help Indigenous Australians to describe their drinking. In a stratified sample of Indigenous Australians in urban and remote/regional sites, the app was able to describe preferred alcohol types, containers and consumption. Most participants either consumed nothing (21.7%) or if they drank, drank at short-term risky levels (95.6%). In this stratified sample, 15% of current drinkers reported experiencing two or more symptoms of alcohol dependence at least monthly.",
        link: "https://bmcmedinformdecismak.biomedcentral.com/articles/10.1186/s12911-019-0879-8",
        states: [
            "QLD",
            "SA",
        ],
        focus: [
            "Research Tools",
        ],
        authors: [
            "Kylie Lee",
            "James Conigrave",
            "Scott Wilson",
            "Jimmy Perry",
            "Noel Hayman",
            "Catherine Zheng",
            "Mustafa Al Ansari",
            "Michael Doyle",
            "Robin Room",
            "Sarah Callinan",
            "Tanya Chikritzhs",
            "Tim Slade",
            "Kate Conigrave",
        ],
    },
    {
        type: "journals",
        anchor: 'journals16',
        title: "Acceptability and feasibility of a computer-based application",
        titleExt: " to help Aboriginal and Torres Strait Islander Australians describe their alcohol consumption",
        publishedby: "Journal of Ethnicity in Substance Abuse",
        year: "2019",
        isResource: false,
        summary: "This paper looked at how acceptable and feasible a tablet application (\"App\") can be to record self-reported alcohol consumption in Aboriginal and Torres Strait Islander Australians. Four communities (1 urban; 3 regional/remote) tested the App, with 246 adult participants (132 males, 114 females). Only six (1.4%) participants reported that the App was \"hard\" to use. Participants appeared to be engaged and to require minimal assistance; nearly half verbally reflected on their drinking or drinking of others. The App has potential for surveys, screening, or health promotion.",
        link: "https://www.ncbi.nlm.nih.gov/pubmed/30887909",
        states: [
            "QLD",
            "SA",
        ],
        focus: [
            "Prevent",
            "Community Programs",
            "Research Tools",
        ],
        authors: [
            "Kylie Lee",
            "James Conigrave",
            "Mustafa Al Ansari",
            "Scott Wilson",
            "Jimmy Perry",
            "Catherine Zheng",
            "Bradley Freeburn",
            "Robin Room",
            "Sarah Callinan",
            "Noel Hayman",
            "Tanya Chikritzhs",
            "Tim Slade",
            "Dennis Gray",
            "Kate Conigrave",
        ],
    },
    {
        type: "journals",
        anchor: 'journals15',
        title: "Asking about the last four drinking occasions on a tablet computer as a way to record alcohol consumption",
        titleExt: " in Aboriginal and Torres Strait Islander Australians: a validation",
        publishedby: "Addiction Science & Clinical Practise",
        year: "2019",
        isResource: false,
        summary: "Alcohol consumption among Indigenous Australians can be irregular, depending on social and geographic context. Alcohol consumption recorded on the Grog Survey App using the last four occasions (Finnish) method was compared with a clinical interview conducted by an Indigenous Australian health professional. Test-retest reliability was assessed by correlations between measures of alcohol consumption recorded on two occasions. The App recorded higher numbers of standard drinks consumed per drinking occasion than the interview. There was reasonable agreement between the App and interview across common reference periods (sensitivity 92.7%, specificity 69.8%, short-term risk; sensitivity 70.7%, specificity 68.8%, long-term risk). Average consumption recorded by the App was as good or better predictor of withdrawal tremors than consumption as estimated by interview. The Finnish method, as delivered by the App, offers an innovative way to collect survey data on alcohol in a population with an intermittent drinking pattern.",
        link: "https://www.ncbi.nlm.nih.gov/pubmed/31039824",
        states: [
            "QLD",
            "SA",
        ],
        focus: [
            "Research Tools",
        ],
        authors: [
            "Kylie Lee",
            "James Conigrave",
            "Sarah Callinan",
            "Robin Room",
            "Jimmy Perry",
            "Tim Slade",
            "Tanya Chikritzhs",
            "Noel Hayman",
            "Teagan Weatherall",
            "Geoffrey Leggat",
            "Dennis Gray",
            "Kate Conigrave",
        ],
    },
    {
        type: "journals",
        anchor: 'journals14',
        title: "‘Why can’t we help protect children too?’",
        titleExt: " Stigma by association among community workers in child protection and its consequences",
        publishedby: "Community Development Journal",
        year: "2019",
        isResource: false,
        summary: "Community workers support families working with child protection agencies. However the stigma attached to ‘bad’ parents can also be passed on to the community workers who support them. This paper describes the findings of in-depth interviews with fifteen community workers, who represent nine agencies assisting families with child protection in a small jurisdiction in Australia. Reduced trust between community workers and support workers may limit the chance for real collaboration.",
        link: "https://academic.oup.com/cdj/advance-article/doi/10.1093/cdj/bsz004/5370028?guestAccessKey=f9c67f3b-cdae-4903-b621-06460516e7b6",
        states: [
            "ACT"
        ],
        focus: [
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "Sharynne Hamilton",
            "Deborah Cleland",
            "Valerie Braithwaite",
        ],
    },
    {
        type: "journals",
        anchor: 'journals12',
        title: "Challenges in accurately assessing prenatal alcohol exposure",
        titleExt: " in a study of fetal alcohol spectrum disorder in a youth detention centre",
        publishedby: "Alcoholism: Clinical and Experimental Research",
        year: "2018",
        isResource: false,
        summary: "Prenatal alcohol exposure can result in permanent disability including Fetal Alcohol Spectrum Disorder (FASD). Young people with FASD are at increased risk of getting into trouble with the law compared to their peers. Data on maternal alcohol consumption during pregnancy was collected during the first Australian study to establish the prevalence of FASD of youth in detention. This article reports on the challenges retrospectively collecting these data for youth in detention in Western Australia.",
        link: "https://onlinelibrary.wiley.com/doi/full/10.1111/acer.13926",
        states: [
            "WA"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "Jacinta Freeman",
            "Carmen Condon",
            "Sharynne Hamilton",
            "Raewyn C. Mutch",
            "Carol Bower",
            "Rochelle E. Watkins"
        ],

    },
    {
        type: "journals",
        anchor: 'journals13',
        title: "Fetal alcohol spectrum disorder and youth justice:",
        titleExt: " a prevalence study among young people sentenced to detention in Western Australia",
        publishedby: "BMJ Open",
        year: "2018",
        isResource: false,
        summary: "Fetal Alcohol Spectrum Disorder (FASD) is characterised by severe, pervasive neurodevelopmental impairment due to prenatal alcohol exposure which can predispose young people to engagement with the law. Conducted in a Western Australian youth detention centre, this article reports on the first Australian study undertaken to establish the prevalence rate of FASD among youth in detention. The study found 36% of young people had FASD with a prevalence rate of 47% for Aboriginal young people.",
        link: "https://bmjopen.bmj.com/content/8/2/e019605",
        states: [
            "WA"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "Carol Bower",
            "Rochelle E Watkins",
            "Raewyn C Mutch",
            "Rhonda Marriott",
            "Jacinta Freeman",
            "Natalie R Kippin",
            "Bernadette Safe",
            "Carmela Pestell",
            "Candy S C Cheung",
            "Helen Shield",
            "Lodewicka Tarratt",
            "Alex Springall",
            "Jasmine Taylor",
            "Noni Walker",
            "Emma Argiro",
            "Suze Leitão",
            "Sharynne Hamilton",
            "Carmen Condon",
            "Hayley M Passmore",
            "Roslyn Giglia"
        ],

    },
    {
        type: "journals",
        anchor: 'journals190',
        title: "Standardised alcohol screening in primary health care services targeting Aboriginal and Torres Strait Islander peoples in Australia",
        titleExt: "",
        publishedby: "Addiction Science & Clinical Practice",
        year: "2018",
        isResource: false,
        summary: "Currently, Aboriginal Community Controlled Health Services use the AUDIT-C brief alcohol screening tool to report on drinking status of their clients. However it is one of many tools used with Indigenous populations in other parts of the world. This narrative review paper considers the validity, acceptability and feasibility of alcohol screening measures in Indigenous primary health care services, including AUDIT, CAGE and IRIS.",
        link: "https://ascpjournal.biomedcentral.com/articles/10.1186/s13722-018-0108-2",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Prevent",
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "M. Moziful Islam", "Helen T. Oni", "Kylie Lee", "Noel Hayman", "Scott Wilson", "Kristie Harrison", "Beth Hummerston", "Rowena Ivers", "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: 'journals11',
        title: "Developing a tablet computer-based application ('App') to measure self-reported alcohol consumption",
        titleExt: " in Indigenous Australians",
        publishedby: "BMC Medical Informatics and Decision Making",
        year: "2018",
        isResource: false,
        summary: "Capturing accurate self-report data on drinking can be difficult in contexts of shared or episodic drinking or using non-standard drinking containers, which can be common in Australia’s First Peoples. In response to this need for a standardised survey tool, the authors used an iterative process to consult clinical, research and cultural experts to create a tablet application (App). This paper describes the development of the Grog Survey App, and its features that may improve self-reporting of alcohol consumption.",
        link: "https://bmcmedinformdecismak.biomedcentral.com/articles/10.1186/s12911-018-0583-0",
        states: [
            "QLD",
            "SA"
        ],
        focus: [
            "Research Tools"
        ],
        authors: [
            "Kylie Lee", "Scott Wilson", "Jimmy Perry", "Robin Room", "Sarah Callinan", "Robert Assan", "Noel Hayman", "Tanya Chikritzhs", "Dennis Gray", "Edward Wilkes", "Peter Jack", "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: 'journals18100701',
        title: "The need to move from describing to evaluating the effectiveness of Indigenous drug and alcohol residential rehabilitation services: a systematic review",
        titleExt: " in Indigenous Australians",
        publishedby: "Current Drug Abuse Reviews",
        year: "2017",
        isResource: false,
        summary: "Despite the important of Indigenous drug and alcohol residential rehabilitation, the knowledge supporting these services is limited. This paper is a systematic review that identifies and classifies the research output in the field of Indigenous drug and alcohol residential rehabilitation services. It also evaluates the research methods used.",
        link: "https://www.ncbi.nlm.nih.gov/pubmed/29714152",
        states: [
            "NSW"
        ],
        focus: [
            "Treat",
            "Reduce Harms"
        ],
        authors: [
            "Doug James", "Anthony Shakeshaft", "Alice Munro", "Ryan Courtney"
        ],

    },
    {
        type: "journals",
        anchor: '1',
        title: "The dissemination of alcohol interventions for Indigenous Australians",
        titleExt: ": A mixed studies review using narrative synthesis",
        publishedby: "Journal of Alcoholism and Drug Dependence",
        year: "2017",
        isResource: false,
        summary: "Alcohol interventions in Indigenous-specific healthcare services are crucial in reducing alcohol harms in these communities. However, interventions need more methodologically rigorous trials, that are measured by outcomes which are meaningful to Indigenous communities themselves. This paper is a systematic review that examines alcohol-related harm reduction interventions for Indigenous Australians, including their acceptability, implementation and evaluation.",
        link: "https://www.omicsonline.org/open-access/the-dissemination-of-alcohol-interventions-for-indigenous-australians-amixed-studies-review-using-narrative-synthesis-2329-6488-1000276.php?aid=92331",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Treat", "Community Programs", "Reduce Harms", "Research Tools"
        ],
        authors: [
            "Megan Whitty", "Anton Clifford-Motopi"
        ],

    },

    {
        type: "journals",
        anchor: '2',
        title: "Healing at home: Developing a model for ambulatory alcohol 'detox'",
        titleExt: " in an Aboriginal community controlled health service",
        publishedby: "International Journal of Indigenous Health",
        year: "2017",
        isResource: false,
        summary: "A critical part of recovering from alcohol dependence involves “detox”, or alcohol withdrawal management. This can be a barrier for Aboriginal Australians, because of the limited availability of detox services as an inpatient. This paper describes and evaluates the feasibility of a model for ambulatory, or “outpatient” alcohol detox delivered by an Australian Aboriginal community controlled health service.",
        link: "https://journals.uvic.ca/index.php/ijih/article/view/16906",
        states: [
            "NSW"
        ],
        focus: [
            "Treat"
        ],
        authors: [
            "Jonathan Brett", "Angela Dawson", "Rowena Ivers", "Leanne Lawrence", "Sarah Barclay", "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: 'journals1',
        title: "Supporting the Aboriginal alcohol and other drug workforce",
        titleExt: " in New South Wales, Australia",
        publishedby: "Drug and Alcohol Review",
        year: "2017",
        isResource: false,
        summary: "Aboriginal alcohol and other drugs (AOD) workers play a key role in making delivery of treatment and care more culturally appropriate. They also provide a friendly face for clients who may expect discrimination on the basis of their race or substance use. Their roles can include counselling, case work, family work, referrals, advocacy and mentoring of younger AOD workers. This paper describes a network that has supported and represented Aboriginal AOD workers in NSW for more than a decade. It uses feedback from the workers themselves. ",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/dar.12465/abstract",
        states: [
            "NSW"
        ],
        focus: [
            "Policy"
        ],
        authors: [
            "Kylie Lee",
            "Bradley Freeburn",
            "Steve Ella",
            "Scott Wilson",
            "Kristie Harrison",
            "Monique McEwan",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Insights into the effective management of support groups",
        titleExt: " for Aboriginal Australian women with substance use disorders",
        publishedby: "Society, Health & Vulnerability",
        year: "2016",
        isResource: false,
        summary: "Social and cultural group support has been proposed to be a beneficial way for participants to access counselling, build skills and knowledge, and socialise with each other. This paper reports on one approach taken to deliver and facilitate a support group for Aboriginal women with substance use disorders in an outpatient context. It uses qualitative data through interviews with both clients and staff.",
        link: "http://www.tandfonline.com/doi/full/10.3402/shv.v7.29474",
        states: [
            "NSW"
        ],
        focus: [
            "Community Programs"
        ],
        authors: [
            "Kylie Lee", "Angela Dawson", "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Mind the gap: What is the difference between alcohol treatment need and access",
        titleExt: " for Aboriginal and Torres Strait Islander Australians?",
        publishedby: "Drug and Alcohol Review",
        year: "2016",
        isResource: false,
        summary: "Indigenous communities and health professionals often point out the difficulty in accessing alcohol treatment services like detox or rehab. This paper examines the likely extent of the gap between voluntary alcohol treatment need and accessibility. It also suggests potential ways to better assess this unmet need.",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/dar.12313/abstract;jsessionid=92EFBBE1A5EE6F427D385130B62E7B8D.f02t01",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Treat",
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "Jonathan Brett",
            "Kylie Lee",
            "Dennis Gray",
            "Scott Wilson",
            "Bradley Freeburn",
            "Kristie Harrison",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Ready, set, go: a cross-sectional survey to understand priorities ",
        titleExt: " and preferences for multiple health behaviour change in a highly disadvantaged group",
        publishedby: "BMC Health Services Research",
        year: "2016",
        isResource: false,
        summary: "Based in an Aboriginal Community Controlled Health Service, this study used computer screening to examine Aboriginal clients’: a) Readiness to change health behaviours b) Preference for addressing multiple risk factors one-by-one or at the same time and c) Preferred types of support services.",
        link: "https://bmchealthservres.biomedcentral.com/articles/10.1186/s12913-016-1701-2",
        states: [
            "NSW"
        ],
        focus: [
            "Reduce Harms"
        ],
        authors: [
            "Natasha Noble",
            "Christine Paul",
            "Robert Sanson-Fisher",
            "Heidi Turon",
            "Nicole Turner",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Does a retrospective seven-day alcohol diary reflect usual alcohol intake",
        titleExt: " for a predominantly disadvantaged Australian Aboriginal population?",
        publishedby: "Substance Use and Misuse",
        year: "2015",
        isResource: false,
        summary: "Screening tools for alcohol consumption can help detect those individuals who are drinking at risky levels. This paper examines how well a seven-day retrospective diary works as a way of recording drinking compared with an estimate of usual drinking by a modified version of the AUDIT (Alcohol Use Disorders Identification Test) Question 3. Drinking patterns are also described (as reported in the seven-day diary).",
        link: "http://www.tandfonline.com/doi/full/10.3109/10826084.2014.980951",
        states: [
            "NSW"
        ],
        focus: [
            "Research Tools"
        ],
        authors: [
            "Natasha Noble",
            "Christine Paul",
            "Kate Conigrave",
            "Kylie Lee",
            "Stephen Blunden",
            "Heidi Turon",
            "Mariko Carey",
            "Patrick McElduff"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Should naltrexone be the first-line medicine to treat alcohol dependence",
        titleExt: " in Aboriginal and Torres Strait Islander populations? An Australian perspective",
        publishedby: "Australian Family Physician",
        year: "2015",
        isResource: false,
        summary: "This article aims to review the efficacy and safety of naltrexone. It discusses reasons why it may be a preferable first-line medicine for Aboriginal and Torres Strait Islander people with alcohol dependence who are seeking to change their drinking. This article argues for increased awareness and access to naltrexone for Aboriginal and Torres Strait Islander peoples with alcohol dependence.",
        link: "http://www.racgp.org.au/afp/2015/november/should-naltrexone-be-the-first-line-medicine-to-treat-alcohol-dependence-in-aboriginal-and-torres-strait-islander-populations-an-australian-perspective/",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Treat"
        ],
        authors: [
            "Jonathan Brett",
            "Rowena Ivers",
            "Michael Doyle",
            "Leanne Lawrence",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Who are the New South Wales Aboriginal drug and alcohol workforce?",
        titleExt: " A first description ",
        publishedby: "Drug and Alcohol Review",
        year: "2015",
        isResource: false,
        summary: "To help understand how to better support and develop the workforce, this paper presents a first description of Aboriginal AOD workers employed in NSW in 2009. This profile includes the composition, training and professional setting of NSW Aboriginal AOD workers. The paper is based on the Master of Philosophy research of Steve Ella.",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/dar.12199/abstract",
        states: [
            "NSW"
        ],
        focus: [
            "Policy"
        ],
        authors: [
            "Steve Ella",
            "Kylie Lee",
            "Steve Childs",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "The impact of a community-based risky drinking intervention (Beat da Binge)",
        titleExt: " on Indigenous young people",
        publishedby: "BMC Public Health ",
        year: "2015",
        isResource: false,
        summary: "This paper reports on an evaluation of a whole-of-community, anti-binge drinking intervention for young people in an Indigenous community in far north Queensland. The intervention was called Beat da Binge. Two major events and multiple minor activities each year were implemented, focusing on drinking education, alcohol-free community-wide social events, and youth-specific sporting and social activities to facilitate self-empowerment. To evaluate the intervention, a survey was developed and implemented at baseline and again two-years after the intervention had finished. Young local people employed as research assistants administered the survey.",
        link: "https://bmcpublichealth.biomedcentral.com/articles/10.1186/s12889-015-2675-4",
        states: [
            "QLD"
        ],
        focus: [
            "Community Programs"
        ],
        authors: [
            "Thameemul Ansari Jainullabudeen",
            "Ailsa Lively",
            "Michele Singleton",
            "Anthony Shakeshaft",
            "Komla Tsey",
            "Janya McCalman",
            "Christopher Doran",
            "Susan Jacups"
        ],

    },
    {
        type: "journals",
        anchor: 'journals7',
        title: "Alcohol and other drug use among Aboriginal and Torres StraitIslander and non-Aboriginal and Torres Strait Islander men entering prison ",
        titleExt: " in New South Wales ",
        publishedby: "Health and Justice Journal",
        year: "2015",
        isResource: false,
        summary: "The aim of this paper is to compare alcohol and other drug (AOD) use among Indigenous and non-Indigenous prison inmates and to identify the implications for providing AOD treatment in the prison setting.",
        link: "https://healthandjusticejournal.springeropen.com/articles/10.1186/s40352-015-0027-1",
        states: [
            "NSW"
        ],
        focus: [
            "Treat",
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "Michael F Doyle",
            "Tony G Butler",
            "Anthony Shakeshaft",
            "Jill Guthrie",
            "Jo Reekie",
            "Peter W Schofield"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Identifying Aboriginal-specific AUDIT-C and AUDIT-3 cutoff scores ",
        titleExt: " for at-risk, high-risk, and likely dependent drinkers using measures of agreement with the 10-item Alcohol Use Disorders Identification Test",
        publishedby: "Addiction Science & Clinical Practice",
        year: "2014",
        isResource: false,
        summary: "This paper aims to identify the AUDIT-C and AUDIT-3 cutoff scores that most closely identify individuals classified as being at-risk drinkers, high-risk drinkers, or likely alcohol dependent by the full (10-item) AUDIT.",
        link: "https://ascpjournal.biomedcentral.com/articles/10.1186/1940-0640-9-17",
        states: [
            "NSW"
        ],
        focus: [
            "Research Tools"
        ],
        authors: [
            "Bianca Calabria",
            "Anton Clifford-Motopi",
            "Anthony Shakeshaft",
            "Kate Conigrave",
            "Lynette Simpson",
            "Donna Bliss",
            "Julaine Allan"
        ],

    },
    {
        type: "journals",
        anchor: 'journals9',
        title: "Better methods to collect self-reported alcohol and other drug use data ",
        titleExt: " from Aboriginal and Torres Strait Islander Australians",
        publishedby: "Drug and Alcohol Review",
        year: "2014",
        isResource: false,
        summary: "Data on the context in which people drink, what they drink, how much and how often, all inform efforts to prevent and treat unhealthy alcohol use. However, among Indigenous Australians there is a lack of good data on drinking. Some experts say that one national survey published in 2008 is out by more than 700% for females and 200% for males. This paper sets out the limitations of existing household survey data on alcohol and other drug use among Indigenous Australians. It suggests approaches that could improve how we collect self-reported data.",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/dar.12159/abstract",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Research Tools"
        ],
        authors: [
            "Kylie Lee",
            "Tanya Chikritzhs",
            "Scott Wilson",
            "Ted Wilkes",
            "Dennis Gray",
            "Robin Room",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Needs of Aboriginal Australian women with comorbid mental and alcohol and other drug use disorders",
        titleExt: "",
        publishedby: "Drug and Alcohol Review",
        year: "2014",
        isResource: false,
        summary: "This study examines experiences of Aboriginal women engaging with treatment services for co-occurring mental health and substance use disorders, and the experiences of their family and of health staff seeking to support them.",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/dar.12127/abstract",
        states: [
            "NSW"
        ],
        focus: [
            "Treat",
            "Reduce Harms"
        ],
        authors: [
            "Kylie Lee",
            "Kaylie Harrison",
            "Katherine Mills",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Outpatient alcohol withdrawal management ",
        titleExt: " for Aboriginal and Torres Strait Islander Australians ",
        publishedby: "Australian Family Physician",
        year: "2014",
        isResource: false,
        summary: "This paper discusses the potential role of outpatient withdrawal management (detox) services for Aboriginal and Torres Strait Islander peoples. Mainstream models of outpatient withdrawal management are also examined. It then describes selected services with experience in providing outpatient alcohol withdrawal for Aboriginal and Torres Strait Islander peoples, and highlights elements perceived by service providers as being important for success.",
        link: "http://www.racgp.org.au/afp/2014/august/outpatient-alcohol-withdrawal-management-for-aboriginal-and-torres-strait-islander-australians/",
        states: [
            "NSW"
        ],
        focus: [
            "Treat"
        ],
        authors: [
            "Jonathan Brett",
            "Leanne Lawrence",
            "Rowena Ivers",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Tailoring a family-based alcohol intervention for Aboriginal Australians",
        titleExt: ", and the experiences and perceptions of health care providers trained in its delivery",
        publishedby: "BMC Public Health",
        year: "2014",
        isResource: false,
        summary: "This study was done in partnership with services Yooruna Gunya, Forbes, in New South Wales. It involved seeking Aboriginal perspectives in an internationally recognised approach to counselling for alcohol and other drug use disorders.",
        link: "https://bmcpublichealth.biomedcentral.com/articles/10.1186/1471-2458-14-322",
        states: [
            "NSW"
        ],
        focus: [
            "Treat",
            "Community Programs"
        ],
        authors: [
            "Bianca Calabria",
            "Anton Clifford-Motopi",
            "Miranda Rose",
            "Anthony Shakeshaft"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "The acceptability to Aboriginal Australians of a family-based intervention",
        titleExt: " to reduce alcohol-related harms ",
        publishedby: "Drug and Alcohol Review",
        year: "2013",
        isResource: false,
        summary: "This study identifies the acceptability to Aboriginal Australians of two family-based approaches to reducing alcohol-related harm: Community Reinforcement Approach (CRA) and Community Reinforcement and Family Training (CRAFT)",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/j.1465-3362.2012.00525.x/abstract",
        states: [
            "NSW"
        ],
        focus: [
            "Treat",
            "Community Programs",
            "Reduce Harms"
        ],
        authors: [
            "Bianca Calabria",
            "Anton Clifford-Motopi",
            "Anthony Shakeshaft",
            "Julaine Allan",
            "Donna Bliss",
            "Chris Doran"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Implementing computerised Aboriginal and Torres Strait Islander health checks in primary care ",
        titleExt: " for clinical care and research: a process evaluation",
        publishedby: "BMC Medical Informatics and Decision Making ",
        year: "2013",
        isResource: false,
        summary: "This paper describes the rationale, implementation and anticipated benefits of computerised Aboriginal and Torres Strait Islander health checks in a primary health care setting.",
        link: "https://bmcmedinformdecismak.biomedcentral.com/articles/10.1186/1472-6947-13-108",
        states: [
            "QLD"
        ],
        focus: [
            "Research Tools"
        ],
        authors: [
            "Geoffrey Spurling",
            "Deborah Askew",
            "Philip Schluter",
            "Noel Hayman"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Pressing need for more evidence to guide efforts to address substance use ",
        titleExt: " among young Indigenous Australians",
        publishedby: "Health Promotion Journal of Australia",
        year: "2013",
        isResource: false,
        summary: "This paper is a narrative review of the evidence which is available to guide efforts to address substance use among young Indigenous Australians. There are very few published peer reviewed journal articles on this topic (8 articles). All had methodological limitations. More systematic evaluation of efforts to prevent (and treat) substance use among young Indigenous Australians is needed. The limited data supports multi-prong interventions, designed with community, to strengthen young people and protect them against substance misuse, rather than simple facts-based education.",
        link: "http://www.publish.csiro.au/he/HE12923",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Community Programs",
            "Reduce Harms"
        ],
        authors: [
            "Kylie Lee",
            "Monique Jagtenberg",
            "Charles Ellis",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "The role of an Aboriginal women's group in meeting the high needs of clients ",
        titleExt: " attending outpatient alcohol and other drug treatment",
        publishedby: "Drug and Alcohol Review",
        year: "2013",
        isResource: false,
        summary: "This paper provides a profile of Aboriginal women attending an inner city outpatient alcohol and other drug treatment service. It also offers insight into how effective the group is, in the eyes of the women and staff members. It also offers suggestions for improvements to the group.",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/dar.12068/abstract",
        states: [
            "NSW"
        ],
        focus: [
            "Treat"
        ],
        authors: [
            "Kylie Lee",
            "Angela Dawson",
            "Kate Conigrave"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Smoking or alcohol dependence among Indigenous Australians",
        titleExt: ": treatment may be needed, not just education",
        publishedby: "Heart, Lung and Circulation",
        year: "2012",
        isResource: false,
        summary: "This paper briefly describes the social and neurobiological factors that drive a dependent smoker or drinker to keep using. The current range of medicines (pharmacological treatments) for dependence is described, and their roles in assisting a person to either stop using or avoid relapse are described. Issues relating to the use of these medicines in Aboriginal Australians are discussed.",
        link: "http://www.sciencedirect.com/science/article/pii/S1443950612010931",
        states: [
            "NSW"
        ],
        focus: [
            "Treat"
        ],
        authors: [
            "Kate Conigrave",
            "Kylie Lee"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "The Alcohol Awareness project: community education and brief intervention ",
        titleExt: " in an urban Aboriginal setting",
        publishedby: "Health Promotion Journal of Australia ",
        year: "2012",
        isResource: false,
        summary: "This paper describes a pilot study of community-based education and brief intervention about alcohol. Existing Aboriginal community-based groups in an urban region were offered interactive education sessions with Aboriginal facilitators. The session was based around a World Health Organization brief intervention, with posters as visual aids. Before education, participants completed the Alcohol Use Disorders Identification Test (AUDIT) and questions on potential barriers to treatment access. After the session, feedback on AUDIT score and one- on - one brief intervention were offered.",
        link: "http://www.publish.csiro.au/he/HE12219",
        states: [
            "NSW"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Community Programs",
            "Reduce Harms",
            "Research Tools"
        ],
        authors: [
            "Kate Conigrave",
            "Brian Freeman",
            "Therese Carroll",
            "Lynette Simpson",
            "Kylie Lee",
            "Vicki Wade",
            "Keren Kiel",
            "Steve Ella",
            "Karen Becker",
            "Bradley Freeburn"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "A systematic review of family-based interventions targeting alcohol misuse ",
        titleExt: " and their potential to reduce alcohol-related harm in indigenous communities ",
        publishedby: "Journal of Studies on Alcohol and Drugs",
        year: "2012",
        isResource: false,
        summary: "This systematic review identifies peer-reviewed published evaluations of family-based alcohol interventions and critiques the methodological quality of those studies. It then describes intervention characteristics, and identifies which interventions appear most promising to reduce alcohol-related harm in Indigenous communities.",
        link: "http://www.jsad.com/doi/10.15288/jsad.2012.73.477",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Community Programs",
            "Reduce Harms"
        ],
        authors: [
            "Bianca Calabria",
            "Anton Clifford-Motopi",
            "Anthony Shakeshaft",
            "Chris Doran"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "How and when health-care practitioners in Aboriginal community controlled health services deliver alcohol screening and brief intervention",
        titleExt: ", and why they don't: A qualitative study. ",
        publishedby: "Drug and Alcohol Review",
        year: "2012",
        isResource: false,
        summary: "The aim of this study is to examine the perceptions and practices of health-care practitioners in Aboriginal Community Controlled Health Services (ACCHSs) with regard to alcohol screening and brief intervention (SBI). The findings of this study informed the development of an intervention to improve uptake of alcohol SBI by health-care practitioners in ACCHS settings. ",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/j.1465-3362.2011.00305.x/abstract",
        states: [
            "NSW"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Community Programs",
            "Reduce Harms"
        ],
        authors: [
            "Anton Clifford-Motopi",
            "Anthony Shakeshaft",
            "Catherine Deans"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Smoking, nutrition, alcohol and physical activity interventions targeting Indigenous Australians",
        titleExt: ": Rigorous evaluations and new directions needed",
        publishedby: "Australian and New Zealand Journal of Public Health",
        year: "2011",
        isResource: false,
        summary: "This paper critiques the evaluations of Indigenous-specific Smoking, poor Nutrition, Alcohol misuse and Physical inactivity (SNAP) intervention studies. It considers the methodological and contextual aspects of the studies.  It examines the effect of these studies on reducing SNAP-related harm in Indigenous Australian communities.",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/j.1753-6405.2010.00631.x/abstract",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Reduce Harms",
            "Research Tools"
        ],
        authors: [
            "Anton Clifford-Motopi",
            "Lisa Pulver",
            "Robyn Richmond",
            "Anthony Shakeshaft",
            "Rowena Ivers"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Evidence-based alcohol screening and brief intervention in Aboriginal community controlled health services",
        titleExt: ": Experiences of health-care providers",
        publishedby: "Drug and Alcohol Review",
        year: "2011",
        isResource: false,
        summary: "This paper describes the experiences of health-care providers delivering alcohol screening and brief intervention (SBI) in Aboriginal Community Controlled Health Services (ACCHSs). It examines the level of tailoring required to increase the likelihood of successfully integrating alcohol SBI into routine health care in ACCHSs.",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/j.1465-3362.2010.00192.x/abstract",
        states: [

        ],
        focus: [
            "Community Programs",
            "Reduce Harms"
        ],
        authors: [
            "Anton Clifford-Motopi",
            "Anthony Shakeshaft"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Brief intervention resource kits for Indigenous Australians",
        titleExt: ": Generally evidence-based, but missing important components",
        publishedby: "Australian and New Zealand Journal of Public Health",
        year: "2010",
        isResource: false,
        summary: "This review aims to identify Indigenous-specific brief intervention kits targeting reductions in Smoking, poor Nutrition, Alcohol misuse and Physical inactivity (SNAP) related harm. It also reviews the quality of these kits, including their evidence-based components, content and patient education materials. ",
        link: "http://onlinelibrary.wiley.com/doi/10.1111/j.1753-6405.2010.00559.x/abstract",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Reduce Harms"
        ],
        authors: [
            "Anton Clifford-Motopi",
            "Lisa Pulver",
            "Robyn Richmond",
            "Anthony Shakeshaft",
            "Rowena Ivers"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Evaluation of a community-driven preventive youth initiative",
        titleExt: " in Arnhem Land, Northern Territory, Australia",
        publishedby: "Drug and Alcohol Review",
        year: "2008",
        isResource: false,
        summary: "This paper evaluates a community-driven initiative established to prevent substance misuse and increase respect for culture and their elders among young people in a group of remote Aboriginal communities in Arnhem Land, Northern Territory.",
        link: "http://onlinelibrary.wiley.com/doi/10.1080/09595230701711124/abstract",
        states: [
            "NT"
        ],
        focus: [
            "Prevent",
            "Community Programs"
        ],
        authors: [
            "Kylie Lee",
            "Kate Conigrave",
            "Alan Clough",
            "Cate Wallace",
            "Edmund Silins",
            "Jackie Rawles"
        ],

    },
    {
        type: "journals",
        anchor: '2',
        title: "Improving services for prevention and treatment of substance misuse",
        titleExt: " for Aboriginal communities in a Sydney area health service",
        publishedby: "Drug and Alcohol Review",
        year: "2008",
        isResource: false,
        summary: "This paper assesses the acceptability and accessibility of mainstream services for Aboriginal Australians with alcohol or drug use disorders in an urban area health service. Priorities for improvement and an implementation plan are identified.",
        link: "http://onlinelibrary.wiley.com/doi/10.1080/09595230701829447/abstract",
        states: [
            "NSW"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "Katharine Teasdale",
            "Kate Conigrave",
            "Keren Kiel",
            "Brad Freeburn",
            "George Long",
            "Karen Becker"
        ],

    },
    {
        type: "reports",
        anchor: 'reports1',
        title: "An evaluation of the Groote Eylandt and Milyakburra alcohol management system",
        titleExt: "",
        publishedby: "Northern Territory Government",
        year: "2007",
        isResource: false,
        summary: "The communities on Groote Eylandt and Bickerton Island did not have regular access to alcohol until the opening of the manganese mine in the 1960s. In the years that followed, alcohol caused rapidly increasing levels of harms. The Aboriginal communities and key stakeholders in the region worked together to try to reduce the severe impact of alcohol. On the 1st July 2005 an Alcohol Management System was implemented, which requires every person in the region, Aboriginal or non- Aboriginal, to hold a permit to buy or consume takeaway alcohol. This report is an independent evaluation of this alcohol management system.",
        link: "http://www.healthinfonet.ecu.edu.au/key-resources/programs-projects?pid=595",
        states: [
            "NT"
        ],
        focus: [
            "Community Programs",
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "Kate Conigrave",
            "Elizabeth Proude",
            "Peter d'Abbs"
        ],

    },
    {
        type: "books",
        anchor: 'books1',
        title: "Aboriginal and Torres Strait Islander Australians ",
        titleExt: "in Addiction Medicine (second edition) [chapter]",
        publishedby: "Oxford University Press.",
        year: "2016",
        isResource: false,
        summary: "This chapter discusses nature and patterns of alcohol and other drug use in Indigenous Australian contexts.",
        link: "https://global.oup.com/academic/product/addiction-medicine-9780198714750?cc=au&lang=en&",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Community Programs",
            "Reduce Harms",
            "Research Tools",
            "Policy"
        ],
        authors: [
            "Kate Conigrave",
            "Brad Freeburn"
        ],

    },
    {
        type: "books",
        anchor: 'books2',
        title: "Aboriginal and Torres Strait Islander Australians ",
        titleExt: "in Addiction Medicine: Principles and Practice [chapter]",
        publishedby: "IP Communications",
        year: "2015",
        isResource: false,
        summary: "This chapter discusses nature and patterns of alcohol and other drug use in Indigenous Australian contexts.",
        link: "http://www.ipcommunications.com.au/contents_add_medicine_full.html",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Community Programs",
            "Reduce Harms"
        ],
        authors: [
            "Kate Conigrave",
            "Kylie Lee",
            "Brad Freeburn"
        ],

    },
    {
        type: "books",
        anchor: 'book3',
        title: "Handbook for Aboriginal alcohol and drug work ",
        titleExt: "",
        publishedby: "University of Sydney",
        year: "2012",
        isResource: true,
        summary: "The Handbook for Aboriginal Alcohol and Drug Work is a practical tool to use in everyday work with clients. It can help build on Aboriginal and Torres Strait Islander health professional skills and knowledge. Although based on the evidence, it is in plain language, and designed to be easy to pick up and read when needed.",
        link: "http://hdl.handle.net/2123/8339",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Community Programs",
            "Reduce Harms",
            "Research Tools",
            "Policy"
        ],
        authors: [
            "Kylie Lee",
            "Bradley Freeburn",
            "Steve Ella",
            "Warren Miller",
            "Jimmy Perry",
            "Kate Conigrave"
        ],

    },
    {
        type: "other",
        anchor: 'other1',
        title: "Alcohol Awareness (third edition)",
        titleExt: "",
        publishedby: "University of Sydney",
        year: "2017",
        isResource: true,
        summary: "The Alcohol Awareness Kit is a visual resource to help staff talk about alcohol with their clients. It includes images and information about harms, recommended drinking limits, and tips on how to change drinking. The kit was designed with input from many Aboriginal and non-Aboriginal health professionals, including the leadership group of the Aboriginal Drug and Alcohol Network NSW.  It is founded on an approach to brief intervention that was validated in a World Health Organization study. It can act as a guide to a brief conversation about unhealthy drinking.",
        link: "http://hdl.handle.net/2123/8779",
        states: [
            "NSW"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Community Programs",
            "Reduce Harms",
            "Research Tools",
            "Policy"
        ],
        authors: [
            "Kate Conigrave",
            "Bradley Freeburn",
            "Kylie Lee",
            "Leadership Group of the Aboriginal Drug and Alcohol Network NSW",
            "Therese Carroll",
            "Meggan Grose",
            "Louise Anderson"
        ],

    },
    {
        type: "other",
        anchor: 'other2',
        title: "Indigenous prison rates are a national shame",
        titleExt: "",
        publishedby: "The Drum",
        year: "2013",
        isResource: false,
        summary: "This article considers new approaches that are needed to address rising incarceration rates of Indigenous Australians in the prison system.",
        link: "http://www.abc.net.au/unleashed/4717444.html",
        states: [
            "NSW",
            "ACT",
            "NT",
            "QLD",
            "TAS",
            "WA",
            "SA",
            "VIC"
        ],
        focus: [
            "Treat",
            "Community Programs",
            "Reduce Harms",
            "Policy"
        ],
        authors: [
            "Paul Simpson",
            "Michael Doyle"
        ],

    },
    {
        type: "other",
        anchor: 'other3',
        title: "Anija [which means alcohol in the Anindilyakwa language]",
        titleExt: "",
        publishedby: "The Perfect World Films",
        year: "2010",
        isResource: false,
        summary: "Filmed on location in the Northern Territory, Anija tells the story of 10-year-old Roy and his 2-year-old sister Desley. Life for Roy is tricky, his parents drink too much and the only person he can trust is far away. When Roy calls on his grandmother for help, she takes matters into her own hands. Anija is a harsh and uplifting tale of one family's struggle to deal with problems from alcohol and was named Best Indigenous Resource at the 2011 Australian Teachers of Media (ATOM) awards. Anija was devised with the Anindilyakwa people of Groote Eylandt and Bickerton Island. It features local people as actors and uses local language to tell a story that comes from the community. Made for Anindilyakwa Land Council by The Perfect World Films, together with Groote Eylandt and Bickerton Island Health Clinics and the University of Sydney. ",
        link: "http://theperfectworld.com.au/anija",
        states: [
            "NT"
        ],
        focus: [
            "Prevent",
            "Treat",
            "Community Programs",
            "Reduce Harms"
        ],
        authors: [
            "Anindilyakwa Land Council",
            "David Hansen",
            "Muriel Jaragba",
            "Jenni Langrell",
            "Kylie Lee"
        ],

    }
];

export const keyPartners = [
    {
        type: "team",
        title: "University of Sydney",
        img: require("./assets/img/2.6_About-Us_Key-Partner_2_Sydney-Uni.png"),
        link: "http://sydney.edu.au"
    },
    {
        type: "team",
        title: "Aboriginal Drug and Alcohol Council SA (ADAC)",
        img: require("./assets/img/2.6_About-Us_Key-Partner_3_ADAC.png"),
        link: "http://adac.org.au/"
    },
    {
        type: "team",
        title: "National Drug and Alcohol Research Centre (NDARC)",
        img: require("./assets/img/2.6_About-Us_Key-Partner_4_NDARC.png"),
        link: "http://ndarc.med.unsw.edu.au"
    },
    {
        type: "team",
        title: "Inala Indigenous Health Service",
        img: require("./assets/img/2.6_About-Us_Key-Partner_5_SQCE.png"),
        link: "http://health.qld.gov.au/iihs"
    },
    {
        type: "team",
        title: "Sydney Local Health District, NSW Ministry Health",
        img: require("./assets/img/2.6_About-Us_Key-Partner_6_Syd-Local-Health-District@2x.png"),
        link: "http://slhd.nsw.gov.au"
    },
    {
        type: "team",
        title: "Illawarra Aboriginal Medical Service",
        img: require("./assets/img/2.6_About-Us_Key-Partner_7_IAMS.png"),
        link: "http://www.illawarraams.com.au"
    },
    {
        type: "team",
        title: "Central Queensland University ",
        img: require("./assets/img/2.6_About-Us_Key-Partner_8_Central-Queensland_Uni.png"),
        link: "http://cqu.edu.au"
    },
    {
        type: "team",
        title: "University of Queensland",
        img: require("./assets/img/2.6_About-Us_Key-Partner_9_Queensland-Uni.png"),
        link: "http://uq.edu.au"
    },
    {
        type: "aux",
        title: "Aboriginal Health Council of SA Inc ",
        img: require("./assets/img/2.6_About-Us_Key-Partner_10_Aboriginal-Health-Council-SA@2x.png"),
        link: "http://ahcsa.org.au"
    },
    {
        type: "aux",
        title: "Griffith University",
        img: require("./assets/img/2.6_About-Us_Key-Partner_11_Griffith-Uni.png"),
        link: "http://griffith.edu.au"
    },
    {
        type: "aux",
        title: "Centre for Alcohol Policy Research (La Trobe Uni)",
        img: require("./assets/img/2.6_About-Us_Key-Partner_12_CAPR.png"),
        link: "http://capr.edu.au"
    },
    {
        type: "aux",
        title: "University of Wollongong",
        img: require("./assets/img/2.6_About-Us_Key-Partner_13_Wollongong-Uni.png"),
        link: "http://uow.edu.au"
    },
    {
        type: "aux",
        title: "National Drug Research Institute",
        img: require("./assets/img/2.6_About-Us_Key-Partner_14_NDRI.png"),
        link: "http://ndri.curtin.edu.au"
    },
    {
        type: "aux",
        title: "UTS",
        img: require("./assets/img/2.6_About-Us_Key-Partner_15_UTS.png"),
        link: "http://uts.edu.au"
    }

];

export const adminLoginMenu: Link[] = [
    {
        name: "login",
        route: "/admin",
        children: []
    }
];

export const adminLogoutMenu: Link[] = [
    {
        name: "logout",
        route: "/auth/logout",
        children: []
    }
];

export const adminMenu: Link[] = [
    {
        name: "people",
        route: "/admin/people",
        children: []
    },
    {
        name: "category",
        route: "/admin/category",
        children: []
    },
    {
        name: "logout",
        route: "/auth/logout",
        children: []
    }
];


// WEBPACK FOOTER //
// ./src/data.tsx